/**
 * Ensures the fixed-position toolbar stays aligned with the bottom of the .left element, rather than the bottom of the entire viewport.”
 */
/* document.addEventListener('DOMContentLoaded', function () {
    var leftContainer = document.querySelector('.left');
    var toolbar = document.querySelector('.object-category-toolbar');

    // Function to calculate the distance between the bottom of .left and the bottom of the viewport
    function getDistanceToViewportBottom() {
        var rect = leftContainer.getBoundingClientRect(); // Get position of .left relative to the viewport
        var viewportHeight = window.innerHeight; // Get the height of the viewport
        var distance = viewportHeight - rect.bottom; // Calculate the distance from the bottom of .left to the bottom of the viewport

        return distance;
    }

    // Function to calculate the distance between the left edge of .left and the left edge of the viewport
    function getDistanceToViewportLeft() {
        var rect = leftContainer.getBoundingClientRect(); // Get position of .left relative to the viewport
        var distance = rect.left; // rect.left gives the distance from the left edge of .left to the viewport's left edge

        return distance;
    }

    function updateToolbarPosition() {
        toolbar.style.position = 'fixed';
        toolbar.style.bottom = getDistanceToViewportBottom() - 1 + 'px';
        toolbar.style.width = leftContainer.clientWidth + 'px'; // Match the width of the container
        toolbar.style.left = getDistanceToViewportLeft() + 'px'; // Align it with .left
    }

    leftContainer.addEventListener('scroll', updateToolbarPosition);
    window.addEventListener('resize', updateToolbarPosition);
}); */

jQuery(window).on('load', function ($) {
    var isMobile = true;
    var htmlWidth = document.querySelector('html').clientWidth;
    var snowContainerBottom = document.querySelector('.snowContainerBottom');
    if (htmlWidth >= 1232) {
        isMobile = false;
    }
    var urlParams = new URLSearchParams(window.location.search);
    var actionParam = urlParams.get('action');

    function loop(fn, min, max) {
        var rand = Math.round(Math.random() * (min - max)) + max;
        // console.log('Activate '+ fn.name +' in: '+ rand / 1000.0+'s');
        setTimeout(function() {
                fn();
            loop(fn, min, max);
        }, rand);
    }

    // Constants
    var cardFront = document.querySelector('.custom-card-front');
    const STAGE =  cardFront.classList.contains('hide') ? "stage-front" : "stage-inside";
    
    const MENU_ID = 'menu';  // Menu identifier
    const MENU_ITEM = '#menu .menu-item';  // Menu item identifier

    const INTERACTABLE = 'interactable';  // Classname for interactable elements

    const CTRL_REMOVE_ID = '#ctrlRemove';
    const CTRL_RAISE_ID  = '#ctrlRaise';
    const CTRL_LOWER_ID  = '#ctrlLower';
    const CTRL_ROTATE_ID = '#ctrlRotate';
    const CTRL_UNDO_ID   = '#ctrlUndo';

    const ROTATE_CONTROL_ID = 'rotate-control';

    const SELECTED = 'selected';  // Class to indicate a selected item

    var finalElementsArray = []
    /**
     * An 'abstract' object from which to inherit common element properties.
     *
     * This prototype assumes that the child object has a property 'element'
     * that is a DOM element.
     */
    var ElementProperties = {}
    ElementProperties.prototype = {

        element: null, // This should be set by the child object


        /**
         * Height dynamic property.
         */
        get height() {
            if (actionParam === 'card') {
                return this._height;
            } else {
                // Don't try to get the height of a cloned element that hasn't yet been placed.
                if (!this.element.parentNode) { return null; }
                if (this._height) {
                    return this._height;
                } else {
                    var rect = this.element.getBoundingClientRect();
                    this._height = rect.bottom - rect.top;
                    return this._height;
                }
            }
        },
        set height(height) {
            this._height = height;
        },


        /**
         * Width dynamic property.
         */
        get width() {
            if (actionParam === 'card') {
                return this._width;
            } else {                
                // Don't try to get the height of a cloned element that hasn't yet been placed.
                if (!this.element.parentNode) { return null; }
                if (this._width) {
                    return this._width;
                } else {
                    var rect = this.element.getBoundingClientRect();
                    this._width = rect.right - rect.left;
                    return this._width;
                }
            }
        },
        set width(width) {
            this._width = width;
        },


        /**
         * Sets up an event handler for both tap and click events in such a way
         * that we prevent "phantom taps" -- when both the click event and the
         * touchend events are fired for one event. Also tests for and ignores
         * drag events.
         *
         * @param function handler - the function to handle the event
         * @param element - element on which to put the events
         */
        onClickTap: function (handler, element) {
            element = element || this.element; // Create a closure on the element

            var dragging = false; // Create a closure on a dragging flag

            /**
             * Notice and flag drag events to ignore.
             */
            jQuery(element).on('touchmove', function (event) {
                dragging = true;
            });

            /**
             * Handles touchend events (when not dragging).
             */
            jQuery(element).on('touchend', function (event) {
                if (!dragging) {
                    handler(event);
                }
                dragging = false;  // We are at the end of the 'touch', so reset dragging flag
                element.tapEventHandled = true;
            });

            /**
             * When this event is fired, check to see if the element's
             * tabEventHandled flag was set. If so, unset it.
             * If not, handle the event like normal.
             */
            jQuery(element).on('click', function (event) {
                if (element.tapEventHandled) {
                    element.tapEventHandled = false;
                    return;
                }
                if (!dragging) {
                    handler(event);
                }
            });
        },


        /**
         * Sets up an event handler for *only* click events. Tap events, which
         * should happen first, will prevent the handler from being run.
         *
         * @param function handler - the function to handle the event
         */
        onClickNotTap: function (handler) {

            var element = this.element;  // Create a closure on the element

            /**
             * Handles touchstart events.
             */
            jQuery(element).on('touchstart', function (event) {
                element.tapEventHappened = true;
            });

            /**
             * When this event is fired, check to see if the element's
             * tabEventHandled flag was set. If so, unset it for the next time.
             * If not, handle the event like normal.
             */
            jQuery(element).on('click', function (event) {
                if (element.tapEventHappened) {
                    element.tapEventHappened = false;
                } else {
                    handler(event);
                }
            });
        }
    };



    /**
     * The Item object is an object that can be placed on the stage.
     *
     * @param element - should be a cloned MenuItem element
     * @param attributes - an object literal of this type:
     * 			{
     * 				name   : item,  // item name (id of MenuItem)
     * 				x      : 0,     // item x position on stage
     * 				y      : 0,     // item y position on stage
     * 				width  : (auto) // item width
     * 				height : (auto) // item height
     * 				angle  : 0,     // item angle of rotation (0 is no rotation)
     * 			}
     */
    function Item(element, attributes,itemId) {
        this.element = element;
        this.element.id = itemId;
        this.element.item = this;  // Store a reference to this object on the element.
        this.stageId = stage.element.id;
        this.name = attributes.name || 'item';
        this.itemId = itemId || 'itemId';

        this.x = attributes.x || 0;
        this.y = attributes.y || 0;
        this._width = attributes.width !== undefined ? attributes.width : 100; // Default to 100
        this._height = attributes.height !== undefined ? attributes.height : 100; // Default to 100
        this.angle = attributes.angle || 0;

        this.place().resize().rotate();  // Set initial position, size, and rotation
        
        this.flipped = false;  // Start out normal
        if (attributes.flipped) { this.flip(); }  // Flip, if flipped attribute is set

        this.rotationControl = new RotationControl(this);
    }
    // Inherit from ElementProperties
    Item.prototype = Object.create(ElementProperties.prototype);

    /**
     * Sets the item's position properties and positions the item on the
     * screen.
     *
     * @param int x
     * @param int y
     *
     * @return Item - returns the instance to be fluent
     */
    Item.prototype.place = function (x, y) {
        this.x = x = x || this.x;  // Uses (this.x, this.y) if
        this.y = y = y || this.y;  // no args are passed.

        // this.element.style.left = x + '%';
        // this.element.style.top = y + '%';
        this.element.style.left = '50%';
        this.element.style.marginLeft = x + 'px';
        this.element.style.marginTop = y + 'px';
        this.element.style.top = '50%';
        
        if (actionParam !== 'card') {            
            this._width = this.element.getBoundingClientRect().width;
            this._height = this.element.getBoundingClientRect().height;
        }

        return this;
    };

    /**
     * Moves item by dx, dy.
     *
     * @param int dx - amount to move by in x axis
     * @param int dy - amount to move by in y axis
     *
     * @return Item - returns the instance to be fluent
     */
    Item.prototype.move = function (dx, dy) {
        dx = dx || 0
        dy = dy || 0
        // var px_offset = ( dx / stage.width ) * 100;  // Convert to percentages
        // var py_offset = ( dy / stage.height ) * 100;
        if (this.x + dx >= stage.width / 2) { // Convert to px from center
            var px_offset = dx;
        } else {
            var px_offset = dx;
        }
        var py_offset = dy;
        // console.log('dx:'+dx+ ' | this.x:'+this.x+' | dy:'+dy+' this.y: '+this.y);
        this.place(this.x + px_offset, this.y + py_offset, this.angle);

        return this;
    };

    /**
     * Resize item to width, height.
     *
     * @param int width
     * @param int height
     *
     * @return Item - returns the instance to be fluent
     */
    Item.prototype.resize = function (width, height) {
        // Use existing width and height if not provided
        width = width !== undefined ? width : this.width; // Use getter
        height = height !== undefined ? height : this.height; // Use getter
        // Prevent resizing out of bounds
        if (width < 20 || width > 500 || height < 20 || height > 500) {
            return this;
        }
        // Update internal dimensions
        this._width = width;
        this._height = height;
        // Apply styles to the element
        this.element.style.width = this._width + 'px'; // Use internal value
        this.element.style.height = this._height + 'px'; // Use internal value
        
        if (actionParam !== 'card') {            
            width = width || null;
            height = height || null;
            // Prevent shrinking Item too much
            if (width && 50 > width) { return this; }
            if (height && 50 > height) { return this; }
            // Prevent resizing Item too large
            if (width && 500 < width) { return this; }
            if (height && 500 < height) { return this; }
            this.width = width = width || this.width;      // Uses (this.width, this.height)
            this.height = height = height || this.height;  // if no args are passed.
            this.element.style.width = this.width + 'px';
            this.element.style.height = this.height + 'px';
        }
        
        return this;
    };

    /**
     * Rotate item.
     *
     * @param int angle
     *
     * @return Item - returns the instance to be fluent
     */
    Item.prototype.rotate = function (angle) {
        // Uses this.angle if no args are passed
        angle = angle || this.angle;

        this.angle = angle;

        var cx = jQuery(this.element).data('width') / 2;
        var cy = jQuery(this.element).data('width') / 2;

        // Change the item's rotation
        this._transform_rotate = ' rotate(' + angle + ' ' + cx + ' ' + cy + ') ';

        return this.transform();
    };

    /**
     * Flip item.
     *
     * @return Item - returns the instance to be fluent
     */
    Item.prototype.flip = function () {
        if (this.flipped) {  // Turn the item right
            // Change the item's rotation
            this._transform_scale = ' scale(1,1) ';

            // Change the item's rotation
            this._transform_translate = ' translate(0, 0) ';

            this.flipped = false;

        } else {  // Otherwise flip it backwards

            // Change the item's rotation
            this._transform_scale = ' scale(-1,1) ';

            // Change the item's rotation
            this._transform_translate = ' translate(-' + jQuery(this.element).data('width') + ', 0)';

            this.flipped = true;
        }

        return this.transform();
    };

    /**
     * Set transform attributess on item
     *
     * @return Item - returns the instance to be fluent
     */
    Item.prototype.transform = function () {
        var transform_string = (this._transform_rotate || '') + (this._transform_scale || '') + (this._transform_translate || '');

        jQuery(this.element).children('g')
            .attr('transform', transform_string);

        return this;
    };

    /**
     * Returns item data for serializing.
     */
    Item.prototype.serialize = function () {
        return {
            'name': this.name,
            'itemId': this.itemId,
            'stage': this.stageId,
            'x': this.x,
            'y': this.y,
            'angle': this.angle,
            'width': this.width,
            'height': this.height,
            'flipped': this.flipped
        };
    };



    /**
     * Rotation control element
     *
     * This control is placed over the selected item.
     * A control is cloned from the master control in the html and a new
     * propeller object is initialized every time a new control is needed.
     *
     * It inherits from the Item object's prototype.
     *
     * @param Item
     */
    function RotationControl(item) {
        this.item = item;  // Item to be controlled
        // Also available in this function scope via closure

        // Control element.
        var control = document.getElementById(ROTATE_CONTROL_ID);
        if (!control) { return; }
        this.element = control.cloneNode(true);
        this.element.id = '';  // Remove id to prevent conflicts
        this.element.classList.add('rotationControl');

        // Put on stage
        stage.element.appendChild(this.element);

        // NOTE: this is using arg 'item' as a closure
        this.propeller = new Propeller(this.element, {
            inertia: 0.87,

            // Rotate selectedItem
            onRotate: function () {
                if (item) { item.rotate(this.angle); }
            },
            // Set the Event flag.
            onDragStart: function () {
                if (item) { stage.rotationControlClickEvent = true; }
            },
            onDragStop: function () {
                if (item) { 
                    updateElementArray(item.element.item.itemId, item.element);
                    stage.saveState(); // Execute logic immediately after dragging stops
                }
            },
            // // Save the state (with the new rotation angle).
            // onStop: function () {
            //     if (item) { 
            //         updateElementArray(parseInt(item.element.item.itemId), item.element);
            //         stage.saveState(); }  // May have timing issues or delays due to inertia
            // },
        });

    };
    // Inherit from ElementProperties
    RotationControl.prototype = Object.create(ElementProperties.prototype);

    /**
     * Shows RotationControl.
     */
    RotationControl.prototype.show = function () {
        this.position();  // Position the element first.
        this.element.style.display = 'block';
    };

    /**
     * Hides RotationControl.
     */
    RotationControl.prototype.hide = function () {
        this.element.style.display = 'none';
    };

    /**
     * Position RotationControl.
     */
    RotationControl.prototype.position = function () {
        // Starting with the largest of the width or height and offsetting
        // position in the opposite direction by half of the difference
        // between the two. The size is adjusted to make it slightly larger
        // than the item.
        var size, adjustment, x, y;
        if (this.item.height < this.item.width) {
            adjustment = this.item.width * 0.5;  // Adjust the size a bit larger than largest side
            size = this.item.width + adjustment;
            offset_x = (adjustment / 2);
            offset_y = (adjustment / 2) + ((this.item.width - this.item.height) / 2);
        } else {
            adjustment = this.item.height * 0.5;
            size = this.item.height + adjustment;
            offset_x = (adjustment / 2) + ((this.item.height - this.item.width) / 2);
            offset_y = (adjustment / 2);
        }

        // Make rotation control at least 50px x 50px
        if (size < 50) {
            size = 50;
            offset_x = (size - this.item.width) / 2;
            offset_y = (size - this.item.height) / 2;
        }

        // Set the size a bit larger than the object
        this.element.style.width = size + 'px';
        this.element.style.height = size + 'px';

        // Position in the center
        this.element.style.position = 'absolute';
        this.element.style.left = '50%';
        this.element.style.top = '50%';

        // Offset based on size differences
        x = this.item.x - offset_x;
        y = this.item.y - offset_y;
        // Offset by using margin:
        this.element.style.marginLeft = x + 'px';
        this.element.style.marginTop = y + 'px';
    };



    /**
     * MenuItem object is a menu item to be selected as Item(s) to put on the
     * stage.
     *
     * !! MenuItem elements MUST have an id for things to work properly. !!
     */
    function MenuItem(element) {

        this.element = element;
        this.element.menu_item = this;  // Store a reference to this object on the element.

        // NOTE: If the menu item does not have an id set, it will cause issues when redrawing.
        this.name = this.element.id || 'item';

        var rect = this.element.getBoundingClientRect();
        this.top = rect.top;
        this.left = rect.left;


        /**
         * Clones the item for placing on stage.
         *
         * @return element clone - returns a cloned DOM element
         */
        var cloneCount = 0;
        this.clone = function () {
            var clone = this.element.cloneNode(true);

            // If there is a linear gradient, update its ID and the path fill to a unique value.
            // This fixes the issue with SVGs with linear gradients getting hidden when switching categories.
           
            // Assuming `clone` is the SVG element that has been cloned
            var linearGradients = clone.querySelectorAll('linearGradient');
            
            // Loop through all linearGradient elements
            Array.prototype.forEach.call(linearGradients, function(linearGradient, index) {
                // Get the existing ID of the linearGradient
                var existingId = linearGradient.id;
            
                // Create a unique ID for this specific linearGradient
                var cloneId = clone.id ? clone.id + '-' + cloneCount + index : 'clone-' + cloneCount + index;
            
                // Update the ID of the linearGradient to the unique ID
                linearGradient.id = cloneId;
            
                // Find all elements within the clone whose fill contains 'url(#existingId)'
                var elementsWithFill = clone.querySelectorAll('[fill*="url(#' + existingId + ')"]');
            
                Array.prototype.forEach.call(elementsWithFill, function(element) {
                    // Update the fill to use the new unique ID
                    element.setAttribute('fill', 'url(#' + cloneId + ')');
                });
            });
            
            cloneCount++;

            clone.id = '';  // Remove id to prevent duplicate ids
            jQuery(clone).addClass(INTERACTABLE);
            clone.style.position = 'absolute';

            return clone;
        };
    }
    // Inherit from ElementProperties
    MenuItem.prototype = Object.create(ElementProperties.prototype);



    /**
     * Menu object container for MenuItems.
     */
    var menu = {

        /**
         * Inherit from ElementProperties
         */
        __proto__: Object.create(ElementProperties.prototype),

        /**
         * Menu container element.
         */
        element: document.getElementById(MENU_ID),

        /**
         * Associative array of MenuItems in the menu
         */
        items: [],

				calculateAttributes: function(target, baseXOffset, baseYOffset,itemId) {
					if( body.classList.contains("just-play") || isMobile ){
                        return {
                            //x: 0, y: 0,
                            // Starts at Center or right stage
                            //x: -(baseXOffset)+target.getBoundingClientRect().left-(target.getBoundingClientRect().width/2),
                            //y: -(baseYOffset)+target.getBoundingClientRect().top+(target.getBoundingClientRect().height/2),
                            x: 0 - (rightContainer.getBoundingClientRect().width / 2) + target.getBoundingClientRect().left - (target.getBoundingClientRect().width/2),
                            y: 0 - rightContainer.getBoundingClientRect().top - rightContainer.getBoundingClientRect().height / 2 + target.getBoundingClientRect().top - (target.getBoundingClientRect().height/2),
                            name: target.menu_item.name,
                        };
                    }else{
                        return {
                            //x: 0, y: 0,
                            // Starts at Center or right stage
                            //x: -(baseXOffset)+target.getBoundingClientRect().left-(target.getBoundingClientRect().width/2),
                            //y: -(baseYOffset)+target.getBoundingClientRect().top+(target.getBoundingClientRect().height/2),
                            x: 0 - leftContainer.getBoundingClientRect().left - (rightContainer.getBoundingClientRect().width / 2) - leftContainer.getBoundingClientRect().width + target.getBoundingClientRect().left - (target.getBoundingClientRect().width/2),
                            y: 0 - rightContainer.getBoundingClientRect().height / 2 + target.getBoundingClientRect().top - (target.getBoundingClientRect().height/2),
                            name: target.menu_item.name,
                        };
                    }
                    
				},
        /**
         * Initializes menu.
         */
        init: function () {
            // Load menu items from dom into this object
            jQuery(MENU_ITEM).each(function (i, menu_item) {
                menu.items[menu_item.id] = new MenuItem(menu_item);
            });


            // TODO: Remove this for mobile
            /**
             * Interact setup for draggable snowman menu items.
             *
             * These items aren't technically 'interactable'. They are merely
             * cloned and a draggable_item interaction is started on the clone.
             *
             * This is an alternative to simply clicking on the item.
             */
            interact(MENU_ITEM).draggable({
                inertia: true,
                onstart: function(event) {
                    event.preventDefault();
                }
            })
            .on('touchstart', function(event) {
                event.preventDefault();  
                event.currentTarget.tapEventHappened = true;
            }, { passive: false })  
            .on('move', function(event) {
                event.preventDefault(); 
                var interaction = event.interaction;
            
                if (interaction.interacting() || !interaction.pointerIsDown) {
                    return;
                }
            
                var target = event.currentTarget;
            
                var element = target.menu_item.clone();
                //var baseXOffset = isMobile ? window.innerWidth / 2 : (window.innerWidth / 2) + ((582 + 24) / 2);
                var baseXOffset = 0;
                var baseYOffset = 0;
                //var baseYOffset = window.innerHeight / 2; 
                var itemId = 'element_'+Date.now()
            
                var attributes = menu.calculateAttributes(target, baseXOffset, baseYOffset);
                var item = stage.addItem(element, attributes,itemId);
                //var dx = (item.width - target.menu_item.width) / 2;
                //var dy = (item.height - target.menu_item.height) / 2;
                var dx = 0;
                var dy = 0;
                item.move(-dx, -dy);
                updateElementArray(itemId,item.element)
                interaction.start({
                    name: 'drag',
                }, stage.interaction, item.element);
            }, { passive: false });
            

            return this;
        },
    }



    /**
     * Stage object on which to place items.
     */
    var stage = {

        /**
         * Inherit from ElementProperties
         */
        __proto__: Object.create(ElementProperties.prototype),

        set element(elementId) {
            // Assign the element by ID
            const element = document.getElementById(elementId);
            if (element) {
                this._currentElement = element;
            }
        },
    
        // Getter for the element
        get element() {
            // Use the current element or determine it dynamically
            if (this._currentElement) {
                return this._currentElement;
            }
    
            var cardFront = document.querySelector('.custom-card-front');
            const STAGE = cardFront.classList.contains('hide') ? "stage-inside" : "stage-front";
            return document.getElementById(STAGE);
        },
        /**
         * Initializes stage.
         */
        init: function () {


            /**
             * Stage click event handler.
             *
             * Note that the individual items themselves do not have click
             * events. Anytime the stage or anything else is clicked inside the
             * stage element, this event is fired. stage.selectItem() follows
             * the target up the DOM to the item element container. If an item
             * element is not found, nothing is selected.
             */
            this.onClickTap(function (event) {
                // If the target was the rotationControl, do nothing
                if (event.target.parentNode === stage.rotationControl) { return; }

                // If the click event occurred on the "mouseUp" of a
                // rotationControlClickEvent, do nothing
                if (stage.rotationControlClickEvent) {
                    stage.rotationControlClickEvent = false;  // Reset the flag.
                    return;
                }

                stage.selectItem(event.target);
            });


            /**
             * Window resize events.
             */
            window.onresize = function (event) {
                stage.resize();  // Keep stage.height and stage.width current
            };


            // Initialize control click handlers
            jQuery(CTRL_REMOVE_ID).click(this.removeItem);
            jQuery(CTRL_RAISE_ID).click(this.raiseItem);
            jQuery(CTRL_LOWER_ID).click(this.lowerItem);
            jQuery(CTRL_ROTATE_ID).click(this.rotateItem);
            jQuery(CTRL_UNDO_ID).click(this.undo);

            // Set up interact js on interactable objects
            this.interaction = interact('.' + INTERACTABLE)
                .draggable({
                    inertia: true,
                    restrict: {
                        restriction: 'parent',
                        endOnly: true,
                        elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
                    },

                    onmove: this.dragItem,
                    onend: function(event){
                        updateElementArray(event.target.item.itemId,event.target.item.element)
                    }

                    /**  TODO: Fix Issue with rotating resizing. */
                }).resizable({
                    preserveAspectRatio: true,
                    edges: { left: true, right: true, bottom: true, top: true },
                    onstart: function (event) {
                        // Check if the element has the 'noresize' class
                        if (event.target.classList.contains('noresize')) {
                            // Disable resizing for this element specifically fro coal
                            //event.interactable.options.resize.enabled = false;
                        }
                    },
                    onmove: this.resizeItem,
                    onend: function(event){
                        updateElementArray(event.target.item.itemId,event.target.item.element)
                    }
                });

            // this.resize();  // Set initial height/width and center coordinates
            this.saveState();  // Saves the first state as an empty stage


            // Don't do rabit animation for /image
            if (!(window.location.href.indexOf("image") >= 0)) {


                function showRabbit() {
                    jQuery('.rabbit').show();
                    setTimeout(function () { jQuery('.rabbit').hide(); }, 20000);
                }
                loop(showRabbit, 23000, 180000);

                function showUFO() {
                    jQuery('.ufo').show();
                    setTimeout(function () { jQuery('.ufo').hide(); }, 10000);
                }
                loop(showUFO, 100000, 180000);
            }

            // setTimeout(function () { jQuery(window).trigger('resize'); }, 1500);

            return this;
        },

        /**
         * Snowman url
         */
        url: {
            get edit() { return '//' + app.siteurl + ((app.user) ? '?action=edit&user'+app.user : ''); },
            get preview() { return '//' + app.siteurl + ((app.user) ? '?action=preview&user'+app.user : ''); },
            get image() { return '//' + app.siteurl + ((app.user) ? '?action=image&user'+app.user : ''); },
            get card() { return '//' + app.siteurl + ((app.user) ? '?action=card&user=' + app.user : ''); },
            get save() { return '//' + app.siteurl + '/save-handler.php'; },
            get reload() { return '//' + app.siteurl + '/save-handler.php' + ((app.user) ? '?user='+app.user : ''); },
        },


        /**
         * Array of Items currently on the stage.
         */
        items: [],

        /**
         * Flag for whether or not to show northern lights
         */
        northern_lights: false,


        /**
         * Gets height, width, and center coordinates.
         */
        resize: function () {
            var rect = this.element.getBoundingClientRect();

            this.height = rect.bottom - rect.op;
            this.width = rect.right - rect.left;

            this.top = rect.top;
            this.left = rect.left;

            this.center = {
                x: this.width / 2,
                y: this.height / 2,
            }
        },


        /**
         * Initialize a new menu.
         */
        menu: menu.init(),


        /**
         * References to the currently selected (focused) item and element.
         */
        selectedItem: null,
        selectedElement: null,


        /**
         * Selects an element (and de-selects previously focused element).
         *
         * If element is null or not an interactable element on the stage,
         * nothing is selected.
         *
         * @param element - DOM element to select
         */
        selectItem: function (element) {
            // If the currently selected item is the same as the new element, do nothing
            // if (stage.selectedElement && stage.selectedElement === element) { 
            //     return element; 
            // }
            
        
            // Hide any visible rotation control, as a new item is being selected
            if (stage.rotationControl) { 
                stage.rotationControl.hide();
                jQuery('.rotating').removeClass('rotating');
            }
        
            // Remove the 'selected' class from the previously selected item, if any
            if (stage.selectedElement) {
                jQuery(stage.selectedElement).removeClass(SELECTED);
            }
        
            // Reset the selected item and element references
            stage.selectedItem = null;
            stage.selectedElement = null;
        
            // If no new element was provided, stop here
            if (!element) { 
                return null; 
            }
        
            // Traverse up the DOM to find the interactable item
            while (element && element !== stage.element) {
                if (jQuery(element).hasClass(INTERACTABLE)) {
                    stage.selectedItem = element.item;
                    stage.selectedElement = element;
                    break;
                }
                element = element.parentNode;  // Move up to the parent element
            }
        
            // Add the 'selected' class to the new selected element
            if (stage.selectedElement) {
                jQuery(stage.selectedElement).addClass(SELECTED);
            }
            
            var currentStage = stage.selectedElement.parentElement.parentElement.parentElement;
            
            // Hide arrows if the current stage is hidden or the selected element is too small
            if (currentStage && currentStage.classList.contains('hide') || stage.selectedElement.clientWidth < 45 || stage.selectedElement.clientHeight < 45) {
                hideResizeArrows();
            } else {                
                topLeftCorners.forEach(function(topLeftCorner) {
                    topLeftCorner.style.display = 'block';
                    topLeftCorner.style.marginLeft = parseInt(element.style.marginLeft) - 9 + 'px';
                    topLeftCorner.style.marginTop = parseInt(element.style.marginTop) - 8 + 'px';
                });
                topRightCorners.forEach(function(topRightCorner) {
                    topRightCorner.style.display = 'block';
                    topRightCorner.style.marginLeft = parseInt(element.style.marginLeft) + element.clientWidth - 8 + 'px';
                    topRightCorner.style.marginTop = parseInt(element.style.marginTop) - 9 + 'px';
                });
                bottomLeftCorners.forEach(function(bottomLeftCorner) {
                    bottomLeftCorner.style.display = 'block';
                    bottomLeftCorner.style.marginLeft = parseInt(element.style.marginLeft) - 8 + 'px';
                    bottomLeftCorner.style.marginTop = parseInt(element.style.marginTop) + element.clientHeight - 9 + 'px';
                });
                bottomRightCorners.forEach(function(bottomRightCorner) {                
                    bottomRightCorner.style.display = 'block';
                    bottomRightCorner.style.marginLeft = parseInt(element.style.marginLeft) + element.clientWidth - 9 + 'px';
                    bottomRightCorner.style.marginTop = parseInt(element.style.marginTop) + element.clientHeight - 8 + 'px';
                });
            }
            
        
            return stage.selectedElement;
        },

        /**
         * Selects the topmost element (and de-selects previously focused element).
         *
         * @return element - returns the selected element
         */
        selectTopmostItem: function () {
            element = (stage.items.length !== 0) ? stage.items[stage.items.length - 1].element : null;
            return this.selectItem(element);
        },


        /**
         * Creates an item by cloning a menu item, adding it to
         * stage.items array, and putting it on the stage.
         *
         * @param element - element to place on screen
         * @param int attributes - see Item object
         *
         * @return element - returns the Item instance
         */
        createItem: function (element, attributes,itemId) {
            var item = new Item(element, attributes,itemId);
            // Add item to items array
            this.items.push(item);

            // Put item on stage
            this.element.appendChild(item.element);

            return item;
        },


        /**
         * Clones an item (element) and puts it on the stage
         *
         * @param element - MenuItem cloned element
         * @param int attributes - see Item object
         *
         * @return element - returns the Item instance
         */
        addItem: function (element, attributes,itemId) {
            var item = stage.createItem(element, attributes,itemId);
        
            // Make this item the selected (focused) item
            stage.selectItem(item.element);
        
            // Attach click event listener to trigger selectItem when clicked
            jQuery(item.element).on('click', function (event) {
                event.stopPropagation(); // Prevents the event from bubbling up to other click handlers
                stage.selectItem(event.currentTarget);
            });
        
            stage.saveState();
        
            return item;
        },


        /**
         * Event handler for drag events.
         *
         * @param event drag_event - event object
         */
        dragItem: function (drag_event) {
            drag_event.preventDefault();
            drag_event.target.item.move(drag_event.dx, drag_event.dy);
            
            topLeftCorners.forEach(function(topLeftCorner) {                
                topLeftCorner.style.marginLeft = parseInt(drag_event.target.item.x) - 9 + 'px';
                topLeftCorner.style.marginTop = parseInt(drag_event.target.item.y) - 8 + 'px';
            });
            topRightCorners.forEach(function(topRightCorner) {                
                topRightCorner.style.marginLeft = parseInt(drag_event.target.item.x) + drag_event.target.clientWidth - 8 + 'px';
                topRightCorner.style.marginTop = parseInt(drag_event.target.item.y) - 9 + 'px';
            });
            bottomLeftCorners.forEach(function(bottomLeftCorner) {                
                bottomLeftCorner.style.marginLeft = parseInt(drag_event.target.item.x) - 8 + 'px';
                bottomLeftCorner.style.marginTop = parseInt(drag_event.target.item.y) + drag_event.target.clientHeight - 9 + 'px';
            });
            bottomRightCorners.forEach(function(bottomRightCorner) {                
                bottomRightCorner.style.marginLeft = parseInt(drag_event.target.item.x) + drag_event.target.clientWidth - 9 + 'px';
                bottomRightCorner.style.marginTop = parseInt(drag_event.target.item.y) + drag_event.target.clientHeight - 8 + 'px';
            });
        },


        /**
         * Event handler for resize events.
         *
         * @param event resize_event - event object
         */
        resizeItem: function (resize_event) {
            // console.log('Resizing');
            resize_event.preventDefault();
            resize_event.target.item
                .resize(resize_event.rect.width, resize_event.rect.height)
                .move(resize_event.deltaRect.left, resize_event.deltaRect.top);
            
            // when resizing, update data-width to new width, which gets used by scaleEleemnts() later
            resize_event.target.dataset.width = resize_event.rect.width;
            
            topLeftCorners.forEach(function(topLeftCorner) {                
                topLeftCorner.style.marginLeft = parseInt(resize_event.target.item.x) - 9 + 'px';
                topLeftCorner.style.marginTop = parseInt(resize_event.target.item.y) - 8 + 'px';
            });
            topRightCorners.forEach(function(topRightCorner) {                
                topRightCorner.style.marginLeft = parseInt(resize_event.target.item.x) + resize_event.target.clientWidth - 8 + 'px';
                topRightCorner.style.marginTop = parseInt(resize_event.target.item.y) - 9 + 'px';
            });
            bottomLeftCorners.forEach(function(bottomLeftCorner) {                
                bottomLeftCorner.style.marginLeft = parseInt(resize_event.target.item.x) - 8 + 'px';
                bottomLeftCorner.style.marginTop = parseInt(resize_event.target.item.y) + resize_event.target.clientHeight - 9 + 'px';
            });
            bottomRightCorners.forEach(function(bottomRightCorner) {                
                bottomRightCorner.style.marginLeft = parseInt(resize_event.target.item.x) + resize_event.target.clientWidth - 9 + 'px';
                bottomRightCorner.style.marginTop = parseInt(resize_event.target.item.y) + resize_event.target.clientHeight - 8 + 'px';
            });
            debounce( stage.saveState, 1000);
        },
        


        /**
         * Rotation control object
         */
        rotationControl: null,

        /**
         * A boolean that is flagged immediately after rotating the rotation
         * control. If the mouse moves off the control, it will register as a
         * different element and the control will disappear in an annoying
         * manner.  This helps to aleviate the problem.
         */
        rotationControlClickEvent: false,


        /**
         * Event handler to show rotation control for rotating the item.
         *
         * @param event rotate_event - event object
         */
        rotateItem: function (rotate_event) {

            // If there are no items, there's nothing to do
            if (stage.items.length < 1) { return; }

            var selected_item = stage.selectedItem;

            // If there isn't a selected item, select the top one.
            if (!selected_item) { selected_item = stage.selectTopmostItem(); }

            stage.rotationControl = selected_item.rotationControl;
            stage.rotationControl.show();
            
            selected_item.element.classList.add('rotating');
            
            hideResizeArrows();
        },


        /**
         * Event handler to flip item.
         *
         * @param event flip_event - event object
         */
        flipItem: function (flip_event) {

            // If there are no items, there's nothing to do
            if (stage.items.length < 1) { return; }

            var selected_item = stage.selectedItem;

            // If there isn't a selected item, select the top one.
            if (!selected_item) { selected_item = stage.selectTopmostItem(); }

            selected_item.flip();
        },


        /**
         * Event handler to raise selectedElement in DOM.
         *
         * @param event raise_event - event object
         */
        raiseItem: function (raise_event) {
            // If there isn't a selected item, there's nothing to do
            if (!stage.selectedElement) { return; }
            // Everytime a new item is selected, hide any possible current rotationControl
            if (stage.rotationControl) {
                stage.rotationControl.hide();
            }

            var item_index = stage.items.indexOf(stage.selectedItem);

            if (stage.items.length > item_index + 1) {  // If there is an item to raise above

                // First, set the order in stage.items[]
                var item_to_move = stage.items.splice(item_index, 1)[0];
                stage.items.splice(item_index + 1, 0, item_to_move);

                // Then insert selectedElement before next item to raise in the DOM
                stage.element.insertBefore(stage.items[item_index].element, stage.selectedElement);
            }
            updateElementArray(stage.selectedElement.id, stage.selectedElement);

            stage.saveState();
        },


        /**
         * Event handler to lower selectedElement in DOM.
         *
         * @param event lower_event - event object
         */
        lowerItem: function (lower_event) {
            // If there isn't a selected item, there's nothing to do
            if (!stage.selectedElement) { return; }

            // Everytime a new item is selected, hide any possible current rotationControl
            if (stage.rotationControl) {
                stage.rotationControl.hide();
            }

            var item_index = stage.items.indexOf(stage.selectedItem);

            if (item_index > 0) {  // If there is an item to raise above

                // First, set the order in stage.items[]
                var item_to_move = stage.items.splice(item_index, 1)[0];
                stage.items.splice(item_index - 1, 0, item_to_move);

                // Then, insert next item before selectedElement to lower selectedElement in the DOM
                stage.element.insertBefore(stage.selectedElement, stage.items[item_index].element);

            }  // Otherwise, nothing to lower item below
            updateElementArray(stage.selectedElement.id, stage.selectedElement);
            stage.saveState();
        },


        /**
         * Event handler to remove selectedElement from DOM.
         *
         * @param event remove_event - event object
         */
        removeItem: function (remove_event) {
            const elementToRemove = document.querySelector('.active-text');
            if (elementToRemove) {
                updateElementArray(elementToRemove.id, elementToRemove, 'remove');
                elementToRemove.remove()
                return false; 
            }
            if (!stage.selectedElement) {
                return;
            }
            // Remove selectedItem from array
            stage.items.splice(stage.items.indexOf(stage.selectedItem), 1);
        
            // Remove selectedItem from stage
            jQuery(stage.selectedElement).remove();
        
            hideResizeArrows();
        
            updateElementArray(stage.selectedElement.id, stage.selectedElement, 'remove');
        
            // Select the highest element (or the last element)
            stage.selectTopmostItem();
        
            stage.saveState();
        },



        states: [],  // Array to hold stage states for undo/redo


        /**
         * Save state method for undo/redo
         *
         * Note that events should occur *after* the change for
         * consistency. This means that the current state is reflected
         * by the topmost item on the stage.states array.
         */
        saveState: function () {
            stage.states.push(stage.serialize());
        },


        /**
         * Undo event handler.
         *
         * Must remove the current state before applying the previous
         * state.
         *
         * @param event undo_event - event object
         */
        undo: function (undo_event) {
            if (finalElementsArray.length > 0) {
                hideResizeArrows();
                var removedElement = finalElementsArray.pop();
               
                if(removedElement.action == 'remove') {
                    var computedStyle = window.getComputedStyle(removedElement.element);
                    var x = parseInt(computedStyle.marginLeft, 10) || 0;
                    var y = parseInt(computedStyle.marginTop, 10) || 0;
                    var name = removedElement.element.getAttribute('data-name') || 'No name attribute';
                    var attributes = {
                        x: x,
                        y: y,
                        name: name
                    };
                   stage.addItem(removedElement.element, attributes, removedElement.id);
                }else {
                    const elementToReplace = document.getElementById(removedElement.id);
                    var matchingElements = finalElementsArray.filter(function (item) {
                        return item.id === removedElement.id;
                    });
                    var previousObject = matchingElements.length > 0 ? matchingElements[matchingElements.length - 1] : null;
            
                    if (matchingElements.length === 1) {
                        // If only one matching element is left, remove it entirely
                        elementToReplace.remove();
                        finalElementsArray = finalElementsArray.filter(function (item) {
                            return item.id !== removedElement.id;
                        });
                    } else if (previousObject) {
                        if (elementToReplace) {
                            elementToReplace.innerHTML = previousObject.element.innerHTML; 
                            elementToReplace.style = previousObject.element.style.cssText; 
                            Array.from(previousObject.element.attributes).forEach(function(attr){
                                elementToReplace.setAttribute(attr.name, attr.value);
                            });
                            console.log('Updated element with ID ' + previousObject.id + ' to match previous state.');
                        } else {
                            console.error('Element with ID ' + previousObject.id + ' not found in the DOM.');
                        }
                    } else {
                        if (elementToReplace) {
                            // Remove the element entirely if no previous state exists
                            elementToReplace.remove();
                            console.log('Removed element with ID ' + removedElement.id + ' as no previous object exists.');
            
                            finalElementsArray = finalElementsArray.filter(function (item) {
                                return item.id !== removedElement.id;
                            });
                        }
                    }
                }
            }

            // stage.states.pop();  // Remove current state
            // stage.states.pop();  // Remove current state

            // // Only store the last 10 states
            // if (stage.states.length > 10) {
            //     stage.states.shift(); // Remove the oldest
            // }

            // // Redraw previous state if there is one
            // if (stage.states.length > 0) {
            //     stage.clear().draw(stage.states[stage.states.length - 1], 'stage-inside');
            //     stage.element = 'stage-front';
            //     stage.draw(stage.states[stage.states.length - 1], 'stage-front');;
            // }

            // // Select the highest element (or the last element)
            // stage.selectTopmostItem();
            
            // var selectedItem = document.querySelector('svg.selected');
            // if (!selectedItem) {
            //     hideResizeArrows();
            // }
            // stage.init();

            // return this;
        },


        /**
         * Clears the stage of everything
         */
        clear: function () {
            for (i = 0, j = stage.items.length; i < j; i++) {
                stage.element.removeChild(stage.items[i].element);
            }
            stage.items = [];

            return this;
        },


        /**
         * Serializes items/stage into json.
         *
         * @return string (json)
         */
        serialize: function () {
            var data = {
                items: [],
                northern_lights: this.northern_lights,
                stage: {
                    // width: this.width,
                    // height: this.height,
                },
            };
            for (var i = 0, len = this.items.length; i < len; i++) {
                data.items.push(this.items[i].serialize());
            }
            return JSON.stringify(data);
        },


        /**
         * Draws a previously saved snowman.
         *
         * @param string (json) - serialized Items object
         */
        draw: function (serialized_data,stageId) {
            var data = JSON.parse(serialized_data); 
            if (!data.items) { return this; }
            for (var i = 0, len = data.items.length; i < len; i++) {
                if(data.items[i].stage == stageId) {
                    var element = this.menu.items[data.items[i].name].clone();
                    this.createItem(element, data.items[i]);
                }
            }
            this.selectTopmostItem();

            return this;
        },
        recreateTextBlock: function(htmlData) {
            var elements = JSON.parse(htmlData);

            elements.forEach(function (item) {
                var newElement = document.createElement('div');
                // newElement.classList.add('text-to-save', 'd-inline-block');
                var newClasses = item.classes.trim().split(/\s+/);
                if(newClasses.length>0 && newClasses[0] != '') {
                    newClasses.forEach(function(cls){
                        newElement.classList.add(cls);
                    })
                }
                newElement.innerHTML = item.html; // Set the inner HTML content
                newElement.className += ' draggable-text text-to-save d-inline-block ui-draggable ui-draggable-handle';
                newElement.style.position = 'relative';
                newElement.style.left = item.x;
                newElement.style.top = item.y;
                newElement.style.transform = 'rotate('+item.angle+'deg)';
                if (item.flipped) {
                    newElement.style.transform += ' scaleX(-1)';
                }
                var stage = document.getElementById(item.stage);
                stage.appendChild(newElement);

            });
        },
        /**
         * Saves a snowman to the db
         */
        save: function () {
            var button = jQuery('.save-button .editor-functions-toolbar__button__description, #save-status');
            var stage_clone = stage;
            var elementsData = [];
          
            jQuery('.text-to-save').each(function () {
                var $element = jQuery(this);
                var width = $element.width(); // Element width
                var height = $element.height(); // Element height
                var angle = $element.data('angle') || 0; // Custom data attribute for rotation
                var flipped = $element.data('flipped') || false; // Custom data attribute for flipped state
                elementsData.push({
                    name: 'text', 
                    stage: $element.attr('data-stage'), 
                    classes: $element.attr('class').replace('draggable-text text-to-save d-inline-block ui-draggable ui-draggable-handle', ''), 
                    html: $element.html(),
                    x: $element.css('left'),
                    y: $element.css('top'),
                    angle: angle,
                    width: width,
                    height: height,
                    flipped: flipped,
                });
            });

            var validIds = finalElementsArray.map(function(item){return item.id});
            stage_clone.items = stage_clone.items.filter(function(item) {
                return validIds.includes(item.itemId)
            });
            button.text('Saving...');
            hideResizeArrows();
            var page_from = 'shared-play';
            if (document.body.classList.contains('just-play')) {
                 page_from = 'just-play';
            } else {
                 page_from = 'shared-card';
            }
            var element = document.getElementById('stage-front');
            var width = 585;
            var height = 800;
            if (element) {
                width = element.offsetWidth;
                height = element.offsetHeight;
            }
            domtoimage.toPng(document.getElementById('stage-front'), {
                filter: function (node) {
                    // Exclude nodes like <link> pointing to external stylesheets
                    return !(node.tagName === 'LINK' && node.rel === 'stylesheet');
                }
            })
                .then(function (dataUrl) {
                jQuery.ajax({
                    url: stage.url.save,
                    data: {
                        "action": "save",
                        data: {
                            stageData: stage_clone.serialize(), 
                            textElements: JSON.stringify(elementsData),
                            imageData: dataUrl ,
                            stage_front: document.getElementById('stage-front').className ,
                            stage_inside: document.getElementById('stage-inside').className,
                            page_from: page_from,
                            stage_width: width,
                            stage_height: height

                        },
                        "user": app.user,
                        "token": app.token,
                    },
                    type: "post",
                    error: function (jqX, status) {
                        alert("Sorry, but your snowman could not be saved. Please try again.");
                    },
                    success: function (response) {
                        try {
                            result = JSON.parse(response);
                            if (result.status && result.status === "success") {
                                app.user = result.user; // Store new user
                                app.token = result.token;    // Store new token
                                // setCookie('user', app.user, .1); // Save user ID as a cookie
                                jQuery('#share-url').html('Click the link icon above to copy your URL.');
                                var cardUrl = document.stage.url.card;

                                // Check if the URL already contains a protocol
                                if (!/^https?:\/\//i.test(cardUrl)) {
                                    const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
                                    cardUrl = protocol + cardUrl;
                                }             
                                jQuery('#share-link').attr("href", cardUrl);
                                jQuery('#submit-link').attr("href", cardUrl);
                                button.text('Saved');
                                if (app.user) {  // Set preview image url
                                    jQuery("#preview-image").attr("src", app.siteurl + "/cards/" + app.user + ".jpg");
                                    jQuery('#submit-link').attr("href", 'mailto:programming@dbswebsite.com?subject=Snowman Submission&body=Please feature my snowman on the Gallery page!%0A' + app.siteurl + "/cards/" + app.user + ".jpg");
                                    jQuery('#share-email').attr("href", 'mailto:?subject=Happy Holidays&body=Happy holidays from me and my snowman!%0A' + app.siteurl + "/cards/" + app.user + ".jpg");
                                    var shareUrl = app.siteurl + "/cards/" + app.user + ".jpg";
                                    var encodedShareUrl = encodeURIComponent(shareUrl);

                                    // Facebook Share
                                    jQuery('#share-facebook').attr("href", 'https://www.facebook.com/sharer/sharer.php?u=' + encodedShareUrl);

                                    // Twitter Share
                                    jQuery('#share-twitter').attr("href", 'https://twitter.com/intent/tweet?text=' + encodeURIComponent('#buildyoursnowman') + '&url=' + encodedShareUrl);

                                    // Pinterest Share
                                    var pinterestUrl = 'https://www.pinterest.com/pin/create/button/?' +
                                        'url=' + encodedShareUrl +
                                        '&media=' + encodeURIComponent(cardUrl) +
                                        '&description=' + encodeURIComponent('Happy Holidays from me and my snowman!');
                                    jQuery('#share-pinterest').attr("href", pinterestUrl);

                                }
                            } else {
                                throw {};
                            }
                        } catch (e) {
                            console.log(e);
                            console.log(response);
                            alert("Sorry. An error occurred, and your snowman could not be saved. Please try again.");
                        }
                    }
                });
            }).catch(function (error) {
                console.error('Error capturing image:', error);
                alert("Failed to capture the screenshot.");
            });
        
            return stage;
        },

        /**
         * Loads a previously saved snowman (using a user id)
         *
         * @param string user id
         */
        load: function (user) {
            user = user || app.user;
            if (!user) { return; }

            jQuery.ajax({
                url: stage.url.reload,
                data: {
                    "action": "reload",
                    "user": user
                },
                type: "post",
                error: function (jqX, status) {
                    console.warn("Could not load snowman data.");
                    console.warn(status);
                },
                success: function (response) {
                    try {
                        result = JSON.parse(response);  // The response was serialized
                        if (result.status && result.status === "success") {
                            // Process stage-front
                            stage.clear().draw(result.data, 'stage-inside');

                            stage.element = 'stage-front';
                            stage.draw(result.data, 'stage-front');
                            stage.recreateTextBlock(result.html)
                            
                            const data = JSON.parse(result.data);
                            setTimeout(function () {
                                if (document.setNorthernLights) {
                                    document.setNorthernLights(data.northern_lights);
                                }
                            }, 3000);
                            document.getElementById('stage-front').className = result.stage_front!=null ? result.stage_front: 'custom-card-front__dummy-stage';
                            document.getElementById('stage-inside').className = result.stage_back!=null ? result.stage_back : 'custom-card-inside__dummy-stage';
                            document.getElementById('stage-front').classList.add('preview');
                            document.getElementById('stage-inside').classList.add('preview');
                            if( body.classList.contains("just-play") ){
                                if (result.stage_width!=null && result.stage_height!=null ){
                                        console.log('Resizing Stage to Fit...' + result.stage_width + ' | ' + result.stage_height);
                                        var newX = .9 * jQuery(window).width(); // w/h = x/y
                                        var newY = (result.stage_height / result.stage_width ) * newX; // nx/y=w/h
                                        console.log('Resizing Stage to Fit...' + newX + ' | ' + newY);

                                        //document.getElementById('stage-front').style.width = newX +'px';
                                        //document.getElementById('stage-front').style.width = newX +'px';
                                        document.getElementById('stage-front').style.height = result.stage_height +'px'; 
                                        document.getElementById('stage-front').style.width = result.stage_width +'px';
                                        document.getElementById('stage-front').style.transform = 'scale('+ newX/result.stage_width +')';
                                        document.getElementById('stage-front').style.left = '50%';
                                        document.getElementById('stage-front').style.marginLeft = '-45vw';
                                    }
                            }
                            // customCardFront.classList.add('show');
                            // introCard.classList.add('hide');
                            // choices.classList.add('hide');
                            // previewHeader.classList.add('hide');
                            document.querySelector('.left').style.display = 'none';
                            // document.querySelector('.intro-card').style.display = 'none';
                            document.body.classList.add(result.page_from!=null ? result.page_from: 'shared-card');
                            document.querySelector('.choices').style.display = 'none';
                            document.querySelector('.custom-card-front').style.display = 'block';
                            var loadedElement = document.querySelector('.loaded')
                            if(loadedElement) {
                                loadedElement.style.background='rgba(27, 101, 102, 0.92)';
                                openCardIcon.classList.remove('hide');
                                var selectedItems = document.querySelectorAll('svg.selected');
                                if (selectedItems) {
                                    selectedItems.forEach(function(item) {
                                        item.classList.remove('selected');
                                    });
                                }
                                hideResizeArrows();
                                const rightElement = document.querySelector('.right');
                                if (rightElement) {
                                    rightElement.style.zIndex = '1';
                                    rightElement.style.position = 'absolute';
                                    rightElement.style.right = '50%';
                                    rightElement.style.transform = 'translateX(50%)';
                                }

                                // RESIZE STAGE TO FIT
                                /* DO NOT FIRE YET
                                function findItemWithLargestMargin(elements) {
                                    let maxMargin = 0;
                                    let elementWithMaxMargin = null;
                                    let elementWithLowMargin = null;
                                  
                                    elements.forEach(element => {
                                      var margin = parseInt(getComputedStyle(element).margin);
                                  
                                      if (margin < maxMargin) {
                                        maxMargin = margin;
                                        elementWithLowMargin = margin;
                                      }
                                      if (margin > maxMargin) {
                                        maxMargin = margin;
                                        elementWithMaxMargin = margin;
                                      }
                                    });
                                  
                                    return [elementWithLowMargin, elementWithMaxMargin];
                                  }
                                  
                                  // Example usage
                                  var SVGitems = document.querySelectorAll(".right svg");
                                  var itemWithLargestMargin = findItemWithLargestMargin(SVGitems);
                                  var getRightSide = document.querySelector(".right");
                                  var width = getRightSide.offsetWidth; 
                                  
                                  console.log(width);
                                  
                                  console.log(itemWithLargestMargin);
                                  var newWidth = width + (-1*itemWithLargestMargin[0]) + 'px';
                                  console.log(newWidth);
                                  document.querySelector(".custom-card-front").style.width = ( newWidth );
                                  */
                            }
                            app.loaded = true;
                        }else {
                            throw {};
                        }
                    } catch (e) {
                        console.warn("Could not load snowman data.");
                        console.log(response);
                        console.log(e);
                    }
                }
            });

            return stage;
        },

        /**
         * Puts stage in preview state to prevent edits.
         */
        preview: function () {
            // Hide any potential rotation controls
            if (this.rotationControl) {
                this.rotationControl.hide();
            }

            // de-select everything
            jQuery(this.selectedElement).removeClass(SELECTED);
            this.selectedItem = null;

            if (app.user) {
                jQuery("#preview-image").show();
            } else {
                jQuery("#preview-image").hide();
            }

            // Prevent edits on stage
            jQuery(this.element).addClass("preview");
        },

        /**
         * Puts stage in edit state to allow edits.
         */
        edit: function () {
            jQuery(this.element).removeClass("preview");
            this.selectTopmostItem();  // Select top item
            jQuery('.save-button .editor-functions-toolbar__button__description').text('Save');  // Change save text from saved to save.
        },

    }

    document.stage = stage.init();


    /**
     * Force element scaling
     */
    var boo = function boo() {
        // resize based on 560 width
        if (jQuery(window).width() > (560 * 1)) {
            jQuery('svg').each(function () {
                jQuery(this).width(jQuery(this).data('width') / 560 * (560 * 1));
                jQuery(this).height(jQuery(this).data('width') / 560 * (560 * 1));

            });
        } else {
            jQuery('svg').each(function () {
                jQuery(this).width(jQuery(this).data('width') / 560 * jQuery(window).width() * 1.25);
                jQuery(this).height(jQuery(this).data('width') / 560 * jQuery(window).width() * 1.25);

            });
        }
    }
    
    var scaleElements = function() {
        // Resize based on 560 width
        var windowWidth = window.innerWidth;
        var svgs = document.querySelectorAll('svg');
        
        if (windowWidth > (632 * 1)) {
            svgs.forEach(function(svg) {
                var dataWidth = svg.getAttribute('data-width');
                if (dataWidth) {                    
                    svg.style.width = (dataWidth / 632 * (632 * 1)) + 'px';
                    svg.style.height = (dataWidth / 632 * (632 * 1)) + 'px';
                }
                if (svg.classList.contains('selected')) {
                    showResizeArrows(svg);
                }
            });
        } else {
            svgs.forEach(function(svg) {
                var dataWidth = svg.getAttribute('data-width');
                if (dataWidth) {
                    svg.style.width = (dataWidth / 632 * windowWidth * 1) + 'px';
                    svg.style.height = (dataWidth / 632 * windowWidth * 1) + 'px';
                }
                if (svg.classList.contains('selected')) {
                    showResizeArrows(svg);
                }
            });
        }
    };

    scaleElements();
    var stageFront = document.getElementById('stage-front');
    var stageInside = document.getElementById('stage-inside');

    if (actionParam === 'card' && window.innerWidth <= 600) {                
        var scaleRatio = window.innerWidth / 600;
        stageFront.style.transform = 'scale(' + scaleRatio + ')';
        stageInside.style.transform = 'scale(' + scaleRatio + ')';
    }
    
    jQuery(window).resize(function () {
        if (actionParam === 'card') {
            if (window.innerWidth <= 600) {                
                var scaleRatio = window.innerWidth / 600;
                stageFront.style.transform = 'scale(' + scaleRatio + ')';
                stageInside.style.transform = 'scale(' + scaleRatio + ')';
            } else {
                stageFront.style.transform = 'none';
                stageInside.style.transform = 'none';
            }
        } else {
            scaleElements();
        }
    })
    
    document.getElementById('share-button').onclick = function() {
        document.stage.save();
    };

    document.body.onkeyup = function (e) {
        // Space key
        // if(e.keyCode == 32){
        // 	document.stage.save();
        // }

        // Backspace key
        if (e.keyCode == 8) {
            // stage.undo();
        }

        // Delete key
        if (e.keyCode == 46) {
            document.stage.delete();
        }

        // 'F' key
        if (e.keyCode == 70) {
            // document.stage.flipItem();
        }
    }

    jQuery('.object-toolbar__inner').addClass('hide');
    jQuery('#menu-lower').removeClass('hide');
    jQuery('.object-category-toolbar__option--lower-torso').addClass('selected');

    jQuery('.object-category-toolbar__option--head').on('click tap', function (event) {
        jQuery('.object-category-toolbar__option').removeClass('selected');
        jQuery('.object-category-toolbar__option--head').addClass('selected');
        jQuery('.object-toolbar__inner').addClass('hide');
        jQuery('#menu-head').removeClass('hide');
        jQuery('#select-element').css('opacity', 1);
        // jQuery('.object-toolbar__options').slick('setPosition');
        closeEditor()
    });

    jQuery('.object-category-toolbar__option--upper-torso').on('click tap', function (event) {
        jQuery('.object-category-toolbar__option').removeClass('selected');
        jQuery('.object-category-toolbar__option--upper-torso').addClass('selected');
        jQuery('.object-toolbar__inner').addClass('hide');
        jQuery('#menu-torso').removeClass('hide');
        jQuery('#select-element').css('opacity', 1);
        // jQuery('.object-toolbar__options').slick('setPosition');
        closeEditor()

    });

    jQuery('.object-category-toolbar__option--lower-torso').on('click tap', function (event) {
        jQuery('.object-category-toolbar__option').removeClass('selected');
        jQuery('.object-category-toolbar__option--lower-torso').addClass('selected');
        jQuery('.object-toolbar__inner').addClass('hide');
        jQuery('#menu-lower').removeClass('hide');
        jQuery('#select-element').css('opacity', 1);
        // jQuery('.object-toolbar__options').slick('setPosition');
        closeEditor()

    });

    jQuery('.object-category-toolbar__option--scene').on('click tap', function (event) {
        jQuery('.object-category-toolbar__option').removeClass('selected');
        jQuery('.object-category-toolbar__option--scene').addClass('selected');
        jQuery('.object-toolbar__inner').addClass('hide');
        jQuery('#menu-scene').removeClass('hide');
        jQuery('#select-element').css('opacity', 1);
        // jQuery('.object-toolbar__options').slick('setPosition');
        closeEditor()

    });

    jQuery('.object-category-toolbar__option--accessories').on('click tap', function (event) {
        jQuery('.object-category-toolbar__option').removeClass('selected');
        jQuery('.object-category-toolbar__option--accessories').addClass('selected');
        jQuery('.object-toolbar__inner').addClass('hide');
        jQuery('#menu-accessories').removeClass('hide');
        jQuery('#select-element').css('opacity', 1);
        closeEditor()
        // jQuery('.object-toolbar__options').slick('setPosition');
    });

    jQuery('.object-category-toolbar__option--text').on('click tap', function (event) {
        jQuery('.object-category-toolbar__option').removeClass('selected');
        jQuery('.object-category-toolbar__option--text').addClass('selected');
        jQuery('.object-toolbar__inner').addClass('hide');
        jQuery('#menu-text').removeClass('hide');
        jQuery('#select-element').css('opacity', 0);
        openEditor();
    });


	/* SNOW EFFECT */

	// Flag to control the snowflake movement
	var paused = false;

    // Function to handle snow effect for a specific container
    function initSnowEffect(snowContainerSelector) {
        var leftSnowContainerTop = document.querySelector('.left .snowContainerTop');
        // var introCard = document.querySelector('.intro-card');
        var leftWidth = leftSnowContainerTop.offsetWidth;
        // var introWidth = introCard.offsetWidth;
        var bottomWidth = snowContainerBottom.offsetWidth;

        leftRatio = leftWidth / 696;
        // introRatio = introWidth / 585;
        bottomRatio = bottomWidth / 696;

        var leftDensity = parseInt(leftRatio * 300);
        // var introDensity = parseInt(introRatio * 300)
        var bottomDensity = parseInt(bottomRatio * 200);
        
        // Get the container
        var snowContainer = document.querySelector(snowContainerSelector);
        var COUNT;
        switch(snowContainerSelector) {
            case '.left .snowContainerTop':
                COUNT = leftDensity;
                break;
            case '.intro-card .snowContainerTop':
                COUNT = introDensity;
                break;
            case '.snowContainerBottom':
                COUNT = bottomDensity;
        }

        // Create the canvas element
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        snowContainer.appendChild(canvas);

        // Get the size of the container
        var width = snowContainer.clientWidth;
        var height = snowContainer.clientHeight;
        var i = 0;
        var active = false;

        function onResize() {
            width = snowContainer.clientWidth;
            height = snowContainer.clientHeight;
            canvas.width = width;
            canvas.height = height;
            ctx.fillStyle = '#FFF';

            // Reset all snowflakes when resized
            for (i = 0; i < COUNT; i++) {
                snowflake = snowflakes[i];
                snowflake.reset();
            }
            
            if (htmlWidth >= 1232) {
                isMobile = false;
            } else {
                isMobile = true;
            }
        }

        var Snowflake = function () {
            this.x = 0;
            this.y = 0;
            this.vy = 0;
            this.vx = 0;
            this.r = 0;

            this.reset();
        }

        Snowflake.prototype.reset = function () {
            this.x = Math.random() * width;
            this.y = Math.random() * -height;

            // Speed and direction
            this.vy = 1 + Math.random() * .3;
            this.vx = 0.5 - Math.random();

            // Size and opacity
            if (snowContainerSelector.includes('.snowContainerTop')) {
                this.r = (1 + Math.random() * 2) * 2; // 200% bigger snowflakes for top container
            } else if (snowContainerSelector.includes('.snowContainerBottom')) {
                this.r = (1 + Math.random() * 2);
            }

            this.o = 0.5 + Math.random() * 0.5;
        }

        canvas.style.position = 'absolute';
        canvas.style.left = canvas.style.top = '0';

        // Declare the snowflakes array locally for each container
        var snowflakes = [],
            snowflake;

        for (i = 0; i < COUNT; i++) {
            snowflake = new Snowflake();
            snowflake.reset();
            snowflakes.push(snowflake);
        }

        function update() {
            // if paused is true, don't move snowflakes
            if (snowContainerSelector.includes('.left') || snowContainerSelector.includes('.snowContainerBottom') || !paused) {
                ctx.clearRect(0, 0, width, height);

                for (i = 0; i < COUNT; i++) {
                    snowflake = snowflakes[i];
                    snowflake.y += snowflake.vy;
                    snowflake.x += snowflake.vx;

                    ctx.globalAlpha = snowflake.o;
                    ctx.beginPath();
                    ctx.arc(snowflake.x, snowflake.y, snowflake.r, 0, Math.PI * 2, false);
                    ctx.closePath();
                    ctx.fill();

                    if (snowflake.y > height) {
                        snowflake.reset();
                    }
                }
            }

            requestAnimFrame(update);
        }

        // Shim layer with setTimeout fallback
        window.requestAnimFrame = (function () {
            return window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                function (callback) {
                    window.setTimeout(callback, 1000 / 60);
                };
        })();

        onResize();
        window.addEventListener('resize', onResize, false);
        update();
    }

    // Run the snow effect in three places
    initSnowEffect('.left .snowContainerTop');
    initSnowEffect('.snowContainerBottom');
    fadeInElement(snowContainerBottom, 9000); // Duration in milliseconds

    var introCard = document.querySelector('.intro-card');
    var choices = document.querySelector('.choices');
    var currentPosition = 0;
    var targetPosition = -45;
    var step = -0.2;
    var interval = 4;
    var currentOpacity = 1;
    var targetOpacity = 0;
    var fadeStep = -0.01;
    var fadeInterval = 10;

    var makeBtn = document.querySelector('.choices__make-a-card button');
    var justPlayBtn = document.querySelector('.choices__just-play button');
    var welcome = document.querySelector('.welcome');
    var createBtn = document.getElementById('create-btn');
    var objToolbar = document.querySelector('.object-toolbar');
    var objCatToolbar = document.querySelector('.object-category-toolbar');
    var instructions = document.querySelector('.object-category-toolbar__instructions');
    var imageControls = document.querySelector('#image-controls');
    var closeInstructionsBtn = document.querySelector('.object-category-toolbar__instructions__close');
    var toolbarOptions = document.querySelector('.object-category-toolbar__options');
    var customCardFront = document.querySelector('.custom-card-front');
    var customCardFrontTips = document.querySelectorAll('.custom-card-front>*:not(button):not(div)');
    customCardFrontTips.forEach(function (tip) {
        tip.classList.add('hide');
    });
    var customCardInside = document.querySelector('.custom-card-inside');
    var body = document.querySelector('body');
    var container = document.querySelector('.container');
    var containerHeader = document.querySelector('.container__header');
    var overlay = document.createElement('div');
    overlay.classList.add('overlay');
    var rightOverlay = document.createElement('div');
    rightOverlay.classList.add('overlay');
    var openCardTab = document.querySelector('#open-card');
    var openCardBtn = document.querySelector('#open-card-btn');
    var openCardIcon = document.querySelector('.open-card-icon');
    var openCardText = document.querySelector('.open-card-icon>span');
    var openCardBtnText = document.querySelector('#open-card-btn>span');
    var closeCardBtn = document.querySelector('#close-card');
    var leftContainer = document.querySelector('.left');
    var rightContainer = document.querySelector('.right');
    var rightHeader = document.querySelector('.right__header');
    var objToolbarAbove = document.querySelector('.object-toolbar__above');
    var previewLink = document.querySelector('#preview-card');
    var previewActions = document.querySelector('.preview-actions');
    var previewHeader = document.querySelector('.preview-header');
    var previewHeaderCloseBtn = document.querySelector('.preview-header>.preview-header__inner>svg');
    var keepDesigningLink = document.querySelector('#keep-designing');
    var gallery = document.querySelector('#gallery');
    var galleryOpenMobile = document.querySelector('#gallery-open-mobile');
    var galleryOpenDesktop = document.querySelector('#gallery-open-desktop');
    var galleryCloseMobile = document.querySelector('#gallery-close-mobile');
    var galleryCloseDesktop = document.querySelector('#gallery-close-desktop');
    var galleryBar = document.getElementById('gallery-bar');
    var galleryToggle = document.querySelector('#gallery-toggle');
    var shareBtn = document.querySelector('#share-button');
    var socialToolbar = document.querySelector('.social-media-toolbar');
    var socialToolbarClose = document.querySelector('.share-close');
    var menuToggleBtns = document.querySelectorAll('.menu-toggle');
    var topLeftCorners = document.querySelectorAll('.top-left');
    var topRightCorners = document.querySelectorAll('.top-right');
    var bottomLeftCorners = document.querySelectorAll('.bottom-left');
    var bottomRightCorners = document.querySelectorAll('.bottom-right');
    var editButton = document.querySelector('.edit-button');
    var shareButtons = document.getElementById('ui__editor-functions-toolbar__buttons');
    var menuWrapper = document.querySelector('.editor-functions-toolbar__mobile__options__wrapper');
    var stageFront = document.querySelector('#stage-front');
    var stageInside = document.querySelector('#stage-inside');
    var stages = [stageFront, stageInside];
    var startOver = document.getElementById('start-over');
    var startOverMenu = document.querySelector('.editor-functions-toolbar__button__start-over');
    var snowContainerBottom = document.querySelector('.snowContainerBottom');

    // Enter into Preview Mode (desktop only)
    function enterPreviewMode() {
        leftContainer.style.opacity = 0;
        leftContainer.style.display = 'none';
        rightContainer.style.position = 'absolute';
        rightContainer.style.right = '50%';
        rightContainer.style.transform = 'translateX(50%)';
        rightContainer.appendChild(rightOverlay);
        body.style.backgroundColor = 'rgba(27, 101, 102, 0.92)';
        previewActions.classList.remove('hide');
        previewHeader.classList.remove('hide');
        openCardIcon.classList.remove('hide');
        customCardFront.style.marginTop = '5rem';
        customCardInside.style.marginTop = '5rem';
        var selectedItems = document.querySelectorAll('svg.selected');
        if (selectedItems) {
            selectedItems.forEach(function(item) {
                item.classList.remove('selected');
            });
        }
        hideResizeArrows();
    }

    window.updateElementArray = function(itemId, elementValue,action) {
        if(!action) {
            action= 'normal'
        }
        finalElementsArray.push(
            {'id':itemId, 'element':elementValue.cloneNode(true),'action':action }
        )
    }

    // Exit out of Preview Mode and go back to editing the card (desktop only)
    function exitPreviewMode() {
        leftContainer.style.opacity = 1;
        leftContainer.style.display = 'block';
        rightContainer.style.position = 'relative';
        rightContainer.style.right = '0';
        rightContainer.style.transform = 'none';
        rightContainer.removeChild(rightOverlay);
        body.style.backgroundColor = '#FFF8E2';
        previewActions.classList.add('hide');
        openCardIcon.classList.add('hide');
        previewHeader.classList.add('hide');
        customCardFront.style.marginTop = '0';
        customCardInside.style.marginTop = '0';
    }
    
    function fadeInElement(element, duration) {
        var start = null; // Start time
        var easing = function (t) {
            return t * t; // Quadratic easing function
        };

        function step(timestamp) {
            if (!start) start = timestamp; // Set the start time
            var progress = (timestamp - start) / duration; // Calculate progress (0 to 1)

            if (progress < 1) {
                var easedOpacity = easing(progress); // Apply the easing function
                element.style.opacity = easedOpacity; // Update the opacity
                requestAnimationFrame(step); // Continue animation
            } else {
                element.style.opacity = 1; // Ensure final opacity is exactly 1
            }
        }

        requestAnimationFrame(step); // Start the animation
    }

    // Open the card to work on the inside
    function openCard() {
        customCardFront.style.display = 'none';
        customCardFront.classList.add('hide');
        customCardInside.style.display = 'block';
        customCardInside.classList.remove('hide');
        openCardBtn.removeEventListener('click', openCard);
        openCardBtn.addEventListener('click', closeCard);
        openCardBtnText.innerText = 'Close Card'
        openCardIcon.removeEventListener('click', openCard);
        openCardIcon.addEventListener('click', closeCard);
        openCardText.innerText = 'Close Card';
        if (isMobile) {
            rightContainer.style.zIndex = 1;
        } else {
            rightContainer.style.zIndex = 0;
        }
        var selectedItem = customCardInside.querySelector('.selected:not(.rotating)');
        if (selectedItem) {
            showResizeArrows(selectedItem);
        } else {
            hideResizeArrows();
        }
    }

    // Close the card to work on the front cover
    function closeCard() {
        customCardInside.style.display = 'none';
        customCardInside.classList.add('hide');
        customCardFront.style.display = 'block';
        customCardFront.classList.remove('hide');
        openCardBtn.removeEventListener('click', closeCard);
        openCardBtn.addEventListener('click', openCard);
        openCardBtnText.innerText = 'Open Card';
        openCardIcon.removeEventListener('click', closeCard);
        openCardIcon.addEventListener('click', openCard);
        openCardText.innerText = 'Open Card';
        var selectedItem = customCardFront.querySelector('.selected:not(.rotating)');
        if (selectedItem) {
            showResizeArrows(selectedItem);
        } else {
            hideResizeArrows();
        }
    }
    
    function showResizeArrows(selectedItem) {
        topLeftCorners.forEach(function(topLeftCorner) {
            topLeftCorner.style.display = 'block';
            topLeftCorner.style.marginLeft = parseInt(selectedItem.style.marginLeft) - 9 + 'px';
            topLeftCorner.style.marginTop = parseInt(selectedItem.style.marginTop) - 8 + 'px';
        });
        topRightCorners.forEach(function(topRightCorner) {
            topRightCorner.style.display = 'block';
            topRightCorner.style.marginLeft = parseInt(selectedItem.style.marginLeft) + selectedItem.clientWidth - 8 + 'px';
            topRightCorner.style.marginTop = parseInt(selectedItem.style.marginTop) - 9 + 'px';
        });
        bottomLeftCorners.forEach(function(bottomLeftCorner) {
            bottomLeftCorner.style.display = 'block';
            bottomLeftCorner.style.marginLeft = parseInt(selectedItem.style.marginLeft) - 8 + 'px';
            bottomLeftCorner.style.marginTop = parseInt(selectedItem.style.marginTop) + selectedItem.clientHeight - 9 + 'px';
        });
        bottomRightCorners.forEach(function(bottomRightCorner) {                
            bottomRightCorner.style.display = 'block';
            bottomRightCorner.style.marginLeft = parseInt(selectedItem.style.marginLeft) + selectedItem.clientWidth - 9 + 'px';
            bottomRightCorner.style.marginTop = parseInt(selectedItem.style.marginTop) + selectedItem.clientHeight - 8 + 'px';
        });
    }
    
    function hideResizeArrows() {
        topLeftCorners.forEach(function(topLeftCorner) {
            topLeftCorner.style.display = 'none';
        });
        topRightCorners.forEach(function(topRightCorner) {
            topRightCorner.style.display = 'none';
        });
        bottomLeftCorners.forEach(function(bottomLeftCorner) {
            bottomLeftCorner.style.display = 'none';
        });
        bottomRightCorners.forEach(function(bottomRightCorner) {
            bottomRightCorner.style.display = 'none';
        });
    }
    
    // Add this to indicate the snowy first screen, then remove when navigating away
    body.classList.add('snowing');
    
    createBtn.addEventListener('click', function (e) {
        e.preventDefault();
        paused = true;
        body.classList.remove('snowing');
        body.scrollTop = 0;
        body.style.overflow = 'hidden';
        container.scrollTop = 0;
        container.style.overflow = 'hidden';
        leftContainer.style.display = 'none';
        galleryBar.style.display = 'none';
        rightContainer.style.display = 'flex';
        rightContainer.classList.add('mobile');
        customCardFront.classList.remove('hide');
        choices.classList.add('active');
        document.querySelector('.left .snowContainerTop').remove();
        document.querySelector('.snowContainerBottom').remove();
    });

    makeBtn.addEventListener('click', function () {
        if (isMobile) {
            containerHeader.classList.remove('hide');
            body.classList.remove('not-gone-to-stage');
            body.classList.add('gone-to-stage');
            body.style.backgroundColor = '#1c6a6c';
            leftContainer.style.display = 'block';
            rightContainer.style.alignItems = 'flex-start';

            setTimeout(function () {
                var newHeight = (window.innerHeight - document.querySelector('#ui__object-category-toolbar__buttons').getBoundingClientRect().height - document.querySelector('#menu').getBoundingClientRect().height - document.querySelector('#image-controls').getBoundingClientRect().height ) - 28 + "px";
                rightContainer.style.height = newHeight;

                var previousHeight = window.innerHeight;
                window.addEventListener('resize', function() {
                    var currentHeight = window.innerHeight;
                
                    // Check if the height has changed
                    if (currentHeight !== previousHeight) {
                        var newHeight = (window.innerHeight - document.querySelector('#ui__object-category-toolbar__buttons').getBoundingClientRect().height - document.querySelector('#menu').getBoundingClientRect().height - document.querySelector('#image-controls').getBoundingClientRect().height ) - 28 + "px";
                        rightContainer.style.height = newHeight;
                        // Update the previousHeight
                        previousHeight = currentHeight;
                    }
                });
            }, 600);
            rightContainer.style.top = '6rem';
        } else {
            instructions.classList.add('active');
        }
        
        menuToggleBtns.forEach(function(menuToggleBtn) {
            menuToggleBtn.classList.remove('hide');
        });
        leftContainer.style.padding = '5rem 3rem 3rem';
        welcome.classList.remove('active');
        choices.classList.remove('active');
        choices.classList.add('hide');
        customCardFront.style.display = 'block';
        objToolbar.classList.remove('hide-desktop', 'hide');
        imageControls.classList.add('active');
        body.appendChild(overlay);

        // delays the removal of the snow effect until it has faded all the way out (opacity transition)
        setTimeout(function () {
            // removes both snow effects on the left once the welcome stuff is fully hidden so that it doesn't continue to use resources
/*             document.querySelector('.left .snowContainerTop').remove();
            document.querySelector('.snowContainerBottom').remove(); */
            objCatToolbar.classList.add('active');
            rightContainer.style.zIndex = 1;
            setTimeout(function () {
                toolbarOptions.classList.remove('hide');

                setTimeout(function () {
                    customCardFront.classList.remove('hide');

                    setTimeout(function () {
                        customCardFrontTips.forEach(function (tip) {
                            tip.classList.remove('hide');
                        });
                    });
                })
            }, 600);
        }, 600);
    });

    justPlayBtn.addEventListener('click', function () {       
        body.classList.remove('not-gone-to-stage');
        body.classList.add('gone-to-stage');
        if (isMobile) {
            body.style.backgroundColor = '#1c6a6c';
            containerHeader.classList.remove('hide');
            leftContainer.style.display = 'block';
            toolbarOptions.classList.remove('hide');
        } else {
            rightHeader.classList.remove('hide');
        }
        
        menuToggleBtns.forEach(function(menuToggleBtn) {
            menuToggleBtn.classList.remove('hide');
        });
        body.classList.add('just-play');
        leftContainer.style.padding = '5rem 3rem 3rem';
        welcome.classList.remove('active');
        choices.classList.remove('active');
        choices.classList.add('hide');
        container.style.padding = '0';
        container.style.width = '100%';
        leftContainer.style.width = '100%';
        rightContainer.classList.add('just-play');
        objToolbar.classList.remove('hide-desktop', 'hide');
        objToolbar.classList.add('just-play');
        objToolbarAbove.style.display = 'none';
        objCatToolbar.classList.add('active');
        imageControls.classList.add('active');
        customCardFront.style.display = 'block';
        customCardFront.style.backgroundColor = 'transparent';
        customCardFrontTips.forEach(function (tip) {
            tip.classList.add('hide');
        });
        // Makes div side scrolling

        document.querySelector('#menu-lower .object-toolbar__options').addEventListener('wheel', function(event) {
            if (event.deltaY !== 0) {
                this.scrollLeft += event.deltaY;
            }
        });
        document.querySelector('#menu-torso .object-toolbar__options').addEventListener('wheel', function(event) {
            if (event.deltaY !== 0) {
                this.scrollLeft += event.deltaY;
            }
        });
        document.querySelector('#menu-head .object-toolbar__options').addEventListener('wheel', function(event) {
            if (event.deltaY !== 0) {
                this.scrollLeft += event.deltaY;
            }
        });
        
        // delays the removal of the snow effect until it has faded all the way out (opacity transition)
        setTimeout(function () {
            // removes both snow effects on the left once the welcome stuff is fully hidden so that it doesn't continue to use resources
            document.querySelector('.left .snowContainerTop').remove();
            document.querySelector('.snowContainerBottom').remove();
            // objCatToolbar.classList.add('active');
            rightContainer.style.zIndex = 1;
            setTimeout(function () {
                toolbarOptions.classList.remove('hide');

                setTimeout(function () {
                    customCardFront.classList.remove('hide');
                })
            }, 600);

        }, 600);
        setTimeout(function () {
            var newHeight = (window.innerHeight - document.querySelector('#ui__object-category-toolbar__buttons').getBoundingClientRect().height - document.querySelector('#menu').getBoundingClientRect().height - document.querySelector('#image-controls').getBoundingClientRect().height ) + "px";
            
            rightContainer.style.height = newHeight;
            
            // resize the right container whenever the window is resized vertically
            var previousHeight = window.innerHeight;
            window.addEventListener('resize', function() {
                var currentHeight = window.innerHeight;

                // Check if the height has changed
                if (currentHeight !== previousHeight) {
                    var newHeight = (window.innerHeight - document.querySelector('#ui__object-category-toolbar__buttons').getBoundingClientRect().height - document.querySelector('#menu').getBoundingClientRect().height - document.querySelector('#image-controls').getBoundingClientRect().height ) + "px";
                    rightContainer.style.height = newHeight;
                    // Update the previousHeight
                    previousHeight = currentHeight;
                }
            });
        }, 2600);
        
    });

    startOver.addEventListener('click', function() {
        // Refresh screen
        location.reload();
        // leftContainer.style.padding = '5vh 3rem 3rem';
        // Remove active class from ____
        // Add active class to "choices"
        // choices.classList.add('active');
        // Add active class to "welcome"
        // welcome.classList.add('active');
    });
    
    startOverMenu.addEventListener('click', function() {
        location.reload();
    })

    overlay.addEventListener('click', function () {
        overlay.remove();
        // Hide tips
        customCardFrontTips.forEach(function (tip) {
            tip.classList.add('hide');
        });
        // Hide instructional box
        instructions.classList.remove('active');
    });

    closeInstructionsBtn.addEventListener('click', function () {
        instructions.classList.remove('active');
    });

    openCardTab.addEventListener('click', function () {
        openCard();
    });

    openCardIcon.addEventListener('click', function () {
        openCard();
    });
    
    openCardBtn.addEventListener('click', function() {
        openCard();
    });

    closeCardBtn.addEventListener('click', function () {
        closeCard();
    });

    previewLink.addEventListener('click', function (e) {
        e.preventDefault();
        enterPreviewMode();
    });

    keepDesigningLink.addEventListener('click', function (e) {
        e.preventDefault();
        exitPreviewMode();
    });

    previewHeaderCloseBtn && previewHeaderCloseBtn.addEventListener('click', function () {
        exitPreviewMode();
    });

    galleryOpenMobile.addEventListener('click', function (e) {
        e.preventDefault();
        body.classList.remove('snowing');
        gallery.classList.remove('hidden');
    });
    
    galleryOpenDesktop.addEventListener('click', function (e) {
        e.preventDefault();
        body.classList.remove('snowing');
        gallery.classList.remove('hidden');
        container.style.display = 'none';
        var newUrl = window.location.origin + '/happyholidays/snowman-gallery';
        window.history.pushState({ path: newUrl }, '', newUrl);
    });

    galleryCloseMobile.addEventListener('click', function () {
        body.classList.add('snowing');
        gallery.classList.add('hidden');
        menuWrapper.style.position = 'fixed';
        document.body.classList.remove('menu-open');
        document.getElementById('ui__object-category-toolbar__buttons').classList.remove('hide');
        
        // If the gallery was opened from the welcome screen, when closing, restore it to the welcome screen. Otherwise, restore it to the edit screen.
        if (!welcome.classList.contains('active')) {
            document.getElementById('menu').classList.remove('hide');
            objToolbar.classList.remove('hide-desktop', 'hide');
            objCatToolbar.classList.add('active');
            toolbarOptions.classList.remove('hide');
            body.scrollTop = 0;
            body.style.overflow = 'hidden';
            container.scrollTop = 0;
            container.style.overflow = 'hidden';
        }
    })
    
    galleryCloseDesktop.addEventListener('click', function () {
        body.classList.add('snowing');
        gallery.classList.add('hidden');
        container.style.display = 'flex';
        menuWrapper.style.position = 'fixed';

        if (!welcome.classList.contains('active')) {
            objCatToolbar.classList.add('active');
            document.body.classList.remove('menu-open');
            document.getElementById('ui__object-category-toolbar__buttons').classList.remove('hide');
            document.getElementById('menu').classList.remove('hide');
            objToolbar.classList.remove('hide-desktop', 'hide');
        }
    });
    
/*     galleryToggle.addEventListener('click', function() {
        if (welcome.classList.contains('active')) {
            welcome.classList.remove('active');
            rightContainer.style.display = 'flex';
            menuToggleBtn.classList.remove('hide');
            openCardBtn.classList.remove('hide');
            customCardFront.style.display = 'block';
            introCard.style.display = 'none';
            rightContainer.classList.add('mobile');
            objToolbar.classList.remove('hide-desktop', 'hide');
            customCardFront.classList.remove('hide');
            document.querySelector('.right .snowContainerTop').remove();
            document.querySelector('.left .snowContainerTop').remove();
            document.querySelector('.snowContainerBottom').remove();
            galleryBar.style.display = 'none';
            objCatToolbar.classList.add('active');
            toolbarOptions.classList.remove('hide');
            imageControls.classList.add('active');
            body.scrollTop = 0;
            body.style.overflow = 'hidden';
            container.scrollTop = 0;
            container.style.overflow = 'hidden';
        }
    }); */
    
    shareBtn.addEventListener('click', function () {
		document.querySelector("#ui__editor-functions-toolbar__buttons").classList.add("active");
    });

    socialToolbarClose.addEventListener('click', function() {
        socialToolbar.classList.toggle('hide');
    })

    menuToggleBtns.forEach(function(menuToggleBtn) {
        menuToggleBtn.addEventListener('click', function () {
            if (menuToggleBtn.classList.contains('close')) {
                menuWrapper.style.position = 'fixed';
                objCatToolbar.classList.add('active');
                document.body.classList.remove('menu-open');
                container.style.backgroundColor = 'transparent';
            } else {
                menuWrapper.style.position = 'absolute';
                objCatToolbar.classList.remove('active');
                document.body.classList.add('menu-open');
                container.style.backgroundColor = '#1c6a6c';
            }
        });
    });

    editButton.addEventListener('click', function() {
        objToolbar.classList.remove('hide');
        objToolbar.classList.remove('hide-desktop');
        document.querySelector("#ui__editor-functions-toolbar__buttons").classList.remove("active");

        toolbarOptions.classList.remove('hide');
        shareButtons.classList.add('hide');

        setTimeout(function() {
            document.body.classList.remove('shared-card');
            document.querySelector('.container .left').style.display = 'block';
        }, 250);
    });
    
    stages.forEach(function(stage) {        
        stage.addEventListener('click', function(event) {
            // Check if the click occurred inside the element with ID 'menu-text'
            var menuText = document.getElementById('menu-text');
            if (menuText && menuText.contains(event.target)) {
                return; // Do nothing if the click is inside '#menu-text'
            }

            // Query both 'svg.selected' and '.active-text'
            var selectedItem = document.querySelector('svg.selected, .active-text');
            if (selectedItem) {
                // Handle logic for 'svg.selected'
                if (selectedItem.classList.contains('rotating')) {
                    selectedItem.classList.remove('rotating');
                    selectedItem.previousElementSibling.style.display = 'none';
                }
                
                // Remove 'selected' class if applicable
                selectedItem.classList.remove('selected');
                selectedItem.classList.remove('active-text');
            }
            hideResizeArrows();
        });
    });

});


var editorInstance;


function openEditor() {
    const editorElement = document.querySelector('#editor');
    if (!editorElement) {
        console.error('Editor element not found!');
        return;
    }

    if (window.editorInstance) {
        jQuery('#text-editor').show();
        return;
    }

    ClassicEditor
        .create(editorElement, {
            toolbar: {
                items: [
                    'heading', '|', 'bold', 'italic'
                ]
            },
            heading: {
                options: [
                    { model: 'paragraph', title: 'Small', class: 'ck-heading_paragraph' },
                    { model: 'heading3', view: 'h3', title: 'Medium', class: 'ck-heading_heading3' },
                    { model: 'heading2', view: 'h2', title: 'Large', class: 'ck-heading_heading2' },
                    { model: 'heading1', view: 'h1', title: 'Extra Large', class: 'ck-heading_heading1' },
                ]
            }
        })
        .then(function (editor) {
            window.editorInstance = editor;
            editor.execute('heading', { value: 'heading2' });
            editor.model.document.on('change:data', function () {
                var editableElement = editor.ui.view.editable.element;
                editableElement.style.color = '#000000';
            });

            console.log('Editor successfully initialized');
        })
        .catch(function (error) {
            console.error('Error initializing editor:', error);
        });

    jQuery('#text-editor').show();
}

function closeEditor() {
    // Destroy CKEditor instance when closing the popup
    jQuery('#text-editor').hide()
    // editorInstance = editor; // In openEditor
    // if (editorInstance) {
    //     editorInstance.destroy()
    //         .then(function () {
    //             console.log('Editor destroyed');
    //         })
    //         .catch(function (error) {
    //             console.error('Error destroying editor', error);
    //         });
    // }
}

$(document).on('click', '.draggable-text', function () {
    $(this).attr('contenteditable', 'true');
    $(this).focus();
});

$(document).on('click', function (event) {
    if (!$(event.target).closest('.draggable-text').length) {
        $('.draggable-text').removeAttr('contenteditable');
    }
});

document.addEventListener('DOMContentLoaded', function() {
    var shareLink = document.getElementById('share-link');

    shareLink.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent the link from navigating
        
        var href = this.getAttribute('href'); // Get the href attribute

        // Create a temporary textarea element
        var tempTextarea = document.createElement('textarea');
        tempTextarea.value = href;

        // Make the textarea invisible and append it to the body
        tempTextarea.style.position = 'fixed'; // Prevent scrolling to the bottom
        tempTextarea.style.opacity = '0';
        document.body.appendChild(tempTextarea);

        // Select and copy the text
        tempTextarea.select();
        try {
            var successful = document.execCommand('copy');
            if (successful) {
                alert('Link copied to clipboard!');
            } else {
                alert('Failed to copy the link.');
            }
        } catch (err) {
            console.error('Failed to copy to clipboard:', err);
            alert('An error occurred while copying the link.');
        }

        // Remove the temporary textarea
        document.body.removeChild(tempTextarea);
    });
});

/**
* SVG Fixer
*
* Fixes references to inline SVG elements when the <base> tag is in use.
* Firefox won't display SVG icons referenced with
* `<svg><use xlink:href="#id-of-icon-def"></use></svg>` when the <base> tag is on the page.
*
* More info:
* - http://stackoverflow.com/a/18265336/796152
* - http://www.w3.org/TR/SVG/linking.html
*
* One would think that setting the `xml:base` attribute fixes things,
* but that is being removed from the platform: https://code.google.com/p/chromium/issues/detail?id=341854
*/

(function (document, window) {
    "use strict";

    /**
    * Initialize the SVG Fixer after the DOM is ready
    */
    document.addEventListener("DOMContentLoaded", function () {

        /**
         * Current URL, without the hash
         */
        var baseUrl = window.location.href
            .replace(window.location.hash, "");

        /**
        *  Find all `use` elements with a namespaced `href` attribute, e.g.
        *  <use xlink:href="#some-id"></use>
        *
        *  See: http://stackoverflow.com/a/23047888/796152
        */
        [].slice.call(document.querySelectorAll("use[*|href]"))

            /**
            * Filter out all elements whose namespaced `href` attribute doesn't
            * start with `#` (i.e. all non-relative IRI's)
            *
            * Note: we're assuming the `xlink` prefix for the XLink namespace!
            */
            .filter(function (element) {
                return (element.getAttribute("xlink:href").indexOf("#") === 0);
            })

            /**
            * Prepend `window.location` to the namespaced `href` attribute value,
            * in order to make it an absolute IRI
            *
            * Note: we're assuming the `xlink` prefix for the XLink namespace!
            */
            .forEach(function (element) {
                element.setAttribute("xlink:href", baseUrl + element.getAttribute("xlink:href"));
            });

    }, false);

}(document, window));


function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function debounce(method, delay) {
    clearTimeout(method._tId);
    method._tId= setTimeout(function(){
        method();
    }, delay);
}




// var snowContainer = document.querySelector('.snowContainer');
// var canvas = document.createElement('canvas');
// snowContainer.appendChild(canvas);
/**
*  Makes a Canvas element that simulates Northern Lights
*/

// settings
var DEBUG = false; // draw the debug line so we can see what it's doing, helps if you turn off the blur filter, too
var CURVE_POINTS = 10; // curve control points, not counting vanishingPoint
var CURVE_POINT_X_JITTER = 1.5; // how far off the base location a point can go, in percentage of difference from previous point
var CURVE_POINT_Y_JITTER = 3.5;
var CURVE_POINT_MAX_FLOAT_X_DIST = 270; // farthest a curve point can float per keyframe
var CURVE_POINT_MAX_FLOAT_Y_DIST = 80;
var CURVE_POINT_MIN_FLOAT_DIST = 15;
var CURVE_POINT_MAX_FLOAT_TIME = 9000; // longest a curve point can take to get to next keyframe
var CURVE_POINT_MIN_FLOAT_TIME = 3000; // shortest a curve point can take to get to next keyframe
var BRUSH_COUNT = 1000;
var BRUSH_WIDTH = 30;
var BRUSH_HEIGHT = 450;
var BRUSH_MIN_SCALE_Y = .02;
var BRUSH_MAX_SCALE_Y_VARIANCE = .5;
var BRUSH_MAX_ALPHA_VARIANCE = .7;
var BRUSH_MAX_ANIM_TIME = 7000;
var BRUSH_MIN_ANIM_TIME = 1500;
var BRUSH_MAX_Z_ANIM_TIME = 80000;
var BRUSH_MIN_Z_ANIM_TIME = 58000;
var BRUSH_ALPHA_DROPOFF = .07;
var MOUSE_X_OFFSET = 50;
var MOUSE_Y_OFFSET = 25;
var mouseXPercentage = .5;
var mouseYPercentage = .5;

/**
* get point in bezier curve
* @param point0 X
* @param point0 Y
* @param control point 0 X
* @param control point 0 Y
* @param control point 1 X
* @param control point 1 Y
* @param point 1 X
* @param point 1 Y
* @param percentage on path to get point of
*
* see http://stackoverflow.com/questions/14174252/how-to-find-out-y-coordinate-of-specific-point-in-bezier-curve-in-canvas
*/
function deCasteljau(p0x, p0y, cp0x, cp0y, cp1x, cp1y, p1x, p1y, t) {
    // In the first step of the algorithm we draw a line connecting p0 and cp0,
    // another line connecting cp0 and cp1, and another still connecting cp1 and p1.
    // Then for all 3 of these lines we're going to find the point on them that is
    // t % from the start of them.
    var Ax = p0x + (t * (cp0x - p0x)),
        Ay = p0y + (t * (cp0y - p0y)),
        Bx = cp0x + (t * (cp1x - cp0x)),
        By = cp0y + (t * (cp1y - cp0y)),
        Cx = cp1x + (t * (p1x - cp1x)),
        Cy = cp1y + (t * (p1y - cp1y));
    // The second step is very much like the first. In the first we connected the
    // four points with lines and then found 3 new points on them. In this step
    // we'll connect those 3 points with lines find 2 new points on them. I'll
    // call these two new points D and E.
    var Dx = Ax + (t * (Bx - Ax)),
        Dy = Ay + (t * (By - Ay)),
        Ex = Bx + (t * (Cx - Bx)),
        Ey = By + (t * (Cy - By));
    // Finally, we can connect these last two points with another line, and find
    // the last point on it which will give us the point on the bezier curve for
    // that t. I'll call this point P.
    var Px = Dx + (t * (Ex - Dx)),
        Py = Dy + (t * (Ey - Dy));

    return {
        x: Px,
        y: Py
    };
}

/**
* curve controller
* @param vanishingPoint X (where the first point locks)
* @param vanishingPoint Y
* @param endPoint X (where the last point starts, but it floats)
* @param endPoint Y
* [@param brushCount] how many brushes to put on the curve
* [@param maxBrushAlpha] maximum alpha for brushes, defaults to 1
* [@param fill] color or canvasGradient to fill the brushes with
*/
var Curve = function (vpX, vpY, vpZ, epX, epY, epZ, brushCount, maxBrushAlpha, fill) {
    // define where the point locks
    this.vanishingPoint = {
        x: vpX,
        y: vpY,
        z: vpZ
    };
    this.endPoint = {
        x: epX,
        y: epY,
        z: epZ
    }
    this.brushCount = brushCount || BRUSH_COUNT;
    this.maxBrushAlpha = maxBrushAlpha || 1;

    this.points = [
        new CurvePoint(this.vanishingPoint.x, this.vanishingPoint.y, this.vanishingPoint.z, 0)
    ];
    // add in-between points
    for (var i = 0; i < CURVE_POINTS - 1; i++) {
        // modifier to fake distance
        var mod = (i + 1) / CURVE_POINTS;
        mod *= mod;

        // randomly generate some points
        var xJitter = Math.random() * CURVE_POINT_X_JITTER - CURVE_POINT_X_JITTER / 2;
        var x = this.vanishingPoint.x + mod * (this.endPoint.x - this.vanishingPoint.x);
        x += xJitter * (x - this.points[i].x);
        var yJitter = (1.2 - mod) * (Math.random() * CURVE_POINT_Y_JITTER - CURVE_POINT_Y_JITTER / 2);
        var y = this.vanishingPoint.y + mod * (this.endPoint.y - this.vanishingPoint.y);
        y += yJitter * (y - this.points[i].y);
        var z = mod * (this.endPoint.z - this.vanishingPoint.z) + this.vanishingPoint.z;

        this.points.push(new CurvePoint(x, y, z, ((Math.random() * .33 + .33) * (x - this.points[i].x))));
    }
    // add last point
    this.points.push(new CurvePoint(this.endPoint.x, this.endPoint.y, this.endPoint.z, 0));

    // create brushes
    this.brushes = [];
    for (var i = 0; i < this.brushCount; i++) {
        var noScale = Math.random() < .01;
        this.brushes.push(
            new Brush(
                this,
                (i / this.brushCount) * (this.endPoint.z - this.vanishingPoint.z) + this.vanishingPoint.z,
                noScale ? "rgb(200, 200, 220)" : fill || null,
                noScale
            )
        );
    }
}
Curve.prototype = {
    drawDebug: function (ctx) {
        // mostly just for debug
        ctx.lineWidth = 2;
        // cp lines
        ctx.setLineDash([2, 2]);
        ctx.strokeStyle = "#f99";
        for (var i = 1, len = this.points.length; i < len; i++) {
            ctx.beginPath();
            var cps = this.points[i].getCps();
            ctx.moveTo(cps[0].x, cps[0].y);
            //ctx.lineTo(this.points[i].x, this.points[i].y);
            ctx.lineTo(cps[1].x, cps[1].y);
            ctx.stroke();
        }

        // build the bezier paths
        var bezierPoints = [];
        for (var i = 0, len = this.points.length; i < len; i++) {
            var cps = this.points[i].getCps();
            if (i !== 0) {
                bezierPoints.push(cps[0]);
            }
            bezierPoints.push(this.points[i]);
            if (i !== len - 1) {
                bezierPoints.push(cps[1]);
            }
        }
        ctx.beginPath();
        ctx.setLineDash([]);
        ctx.strokeStyle = "#c00";
        ctx.moveTo(bezierPoints[0].x, bezierPoints[0].y);
        for (var i = 1, len = bezierPoints.length; i < len; i += 3) {
            ctx.bezierCurveTo(bezierPoints[i].x, bezierPoints[i].y, bezierPoints[i + 1].x, bezierPoints[i + 1].y, bezierPoints[i + 2].x, bezierPoints[i + 2].y);
        }
        ctx.stroke();
    },
    draw: function (ctx) {
        for (var i = 0, len = this.brushes.length; i < len; i++) {
            this.brushes[i].draw(ctx);
        }
    },
    getPointAtZ: function (p) {
        if (p <= this.points[0].z) {
            return this.points[0];
        }
        else if (p >= this.points[this.points.length - 1].z) {
            console.log('over');
            return this.points[this.points.length - 1];
        }
        else {
            var i = 0;
            for (var len = this.points.length; i < len; i++) {
                if (p <= this.points[i].z) {
                    break;
                }
            }
            var lastPoint = this.points[i - 1];
            var lastPointCps = lastPoint.getCps();
            var nextPoint = this.points[i];
            var nextPointCps = nextPoint.getCps();
            var t = (p - lastPoint.z) / (nextPoint.z - lastPoint.z);
            return deCasteljau(lastPoint.x, lastPoint.y, lastPointCps[1].x, lastPointCps[1].y, nextPointCps[0].x, nextPointCps[0].y, nextPoint.x, nextPoint.y, t);
        }
    },
    update: function () {
        // update point positions for floating effect
        for (var i = 0, len = this.points.length; i < len; i++) {
            this.points[i].updatePosition();
        }
        // update brush properties for floating effect
        for (var i = 0, len = this.brushes.length; i < len; i++) {
            this.brushes[i].updatePosition();
        }
    },
    setMaxBrushAlpha: function (alpha) {
        this.maxBrushAlpha = alpha;
    }
}

/**
* curve points
* @param startX
* @param startY
* @param z (affects how much it moves, 0-1)
*/
var CurvePoint = function (x, y, z, cpLength) {
    this.x = x;
    this.y = y;
    this.z = z;
    this.cpLength = cpLength;
    this.cpYOffset = Math.random() * cpLength - cpLength;

    // set up floating
    this.xAnimTime = Math.random() * (CURVE_POINT_MAX_FLOAT_TIME - CURVE_POINT_MIN_FLOAT_TIME) + CURVE_POINT_MIN_FLOAT_TIME;
    this.xVariance = Math.max(Math.random() * this.z * (CURVE_POINT_MAX_FLOAT_X_DIST), CURVE_POINT_MIN_FLOAT_DIST);
    this.xMin = this.x - this.xVariance / 2;
    this.xAnimOffset = Math.random() * Math.PI;

    this.yAnimTime = Math.random() * (CURVE_POINT_MAX_FLOAT_TIME - CURVE_POINT_MIN_FLOAT_TIME) + CURVE_POINT_MIN_FLOAT_TIME;
    this.yVariance = Math.max(Math.random() * this.z * (CURVE_POINT_MAX_FLOAT_Y_DIST), CURVE_POINT_MIN_FLOAT_DIST);
    this.yMin = this.y - this.yVariance / 2;
    this.yAnimOffset = Math.random() * Math.PI;
}
CurvePoint.prototype = {
    getCps: function () {
        return [
            {
                x: this.x - this.cpLength,
                y: this.y - this.cpYOffset
            },
            {
                x: this.x + this.cpLength,
                y: this.y + this.cpYOffset
            }
        ]
    },
    updatePosition: function () {
        if (!this.startTime)
            this.startTime = new Date().getTime();
        var now = new Date().getTime();
        var deltaTime = now - this.startTime;

        this.x = this.xMin + (Math.sin((deltaTime / this.xAnimTime) * Math.PI + this.xAnimOffset) * .5 + .5) * this.xVariance;
        this.x += this.z * (1 - mouseXPercentage * 2) * MOUSE_X_OFFSET;
        this.y = this.yMin + (Math.sin((deltaTime / this.yAnimTime) * Math.PI + this.yAnimOffset) * .5 + .5) * this.yVariance;
        this.y += this.z * (1 - mouseYPercentage * 2) * MOUSE_Y_OFFSET;
    }
}

/**
*  Brushes
*  Jitters are created on init
*  @param curve - what curve the brush sits on
*  @param z - where on the line the brush sits
*/
var Brush = function (curve, z, color, noScale) {
    this.curve = curve;
    this.z = z;
    this.alpha = z * Math.random() * .55 + .15;
    this.scaleYMod = (1 - BRUSH_MIN_SCALE_Y) * Math.random();
    this.scaleXMod = .5 * Math.random() * (2 - this.scaleYMod * 2);
    this.noScale = !!noScale;
    this.color1 = color || "rgb(50, 170, 82)";

    // timings
    this.alphaAnimTime = Math.random() * (BRUSH_MAX_ANIM_TIME - BRUSH_MIN_ANIM_TIME) + BRUSH_MIN_ANIM_TIME;
    this.alphaVariance = Math.max(Math.random() * BRUSH_MAX_ALPHA_VARIANCE, this.alpha);
    this.alphaMin = Math.max(this.alpha - this.alphaVariance / 2, 0);
    this.alphaAnimOffset = Math.random() * Math.PI;

    this.scaleYAnimTime = Math.random() * (BRUSH_MAX_ANIM_TIME - BRUSH_MIN_ANIM_TIME) + BRUSH_MIN_ANIM_TIME;
    this.scaleYVariance = Math.random() * BRUSH_MAX_SCALE_Y_VARIANCE;
    this.scaleYMin = this.scaleY - this.scaleYVariance / 2;
    this.scaleYAnimOffset = Math.random() * Math.PI;

    this.zAnimOffset = this.curve.vanishingPoint.z - (z - this.curve.vanishingPoint.z);
    this.zAnimTime = Math.random() * (BRUSH_MAX_Z_ANIM_TIME - BRUSH_MIN_Z_ANIM_TIME) + BRUSH_MIN_Z_ANIM_TIME;

    if (this.noScale) {
        this.alphaMin = 0;
        this.alphaVariance = 1;
    }
}
Brush.prototype = {
    draw: function (ctx) {
        if (this.z < this.curve.vanishingPoint.z || this.z > this.curve.endPoint.z)
            return false;

        var point = this.curve.getPointAtZ(this.z);

        var alpha = ((.5 + .5 * Math.min(this.z, 1)) * this.alpha * this.curve.maxBrushAlpha);
        if (this.z - this.curve.vanishingPoint.z < BRUSH_ALPHA_DROPOFF) {
            alpha *= (this.z - this.curve.vanishingPoint.z) / BRUSH_ALPHA_DROPOFF;
        }
        else if (this.curve.endPoint.z - this.z < BRUSH_ALPHA_DROPOFF) {
            alpha *= (this.curve.endPoint.z - this.z) / BRUSH_ALPHA_DROPOFF;
        }

        if (!this.noScale) {
            var scaleY = this.z * this.scaleYMod + BRUSH_MIN_SCALE_Y;
            var scaleX = this.z * this.scaleXMod + .5;
        }
        else {
            var scaleY = this.scaleYMod + BRUSH_MIN_SCALE_Y;
            var scaleX = this.scaleXMod + .5;
        }

        ctx.fillStyle = this.color1;
        ctx.globalAlpha = alpha;

        ctx.beginPath();
        ctx.moveTo(point.x, point.y - scaleY * BRUSH_HEIGHT);
        ctx.quadraticCurveTo(point.x + scaleX * BRUSH_WIDTH / 2, point.y - scaleY * BRUSH_HEIGHT, point.x + scaleX * BRUSH_WIDTH / 2, point.y);
        ctx.quadraticCurveTo(point.x + scaleX * BRUSH_WIDTH / 2, point.y + scaleY * BRUSH_WIDTH, point.x, point.y + scaleX * BRUSH_WIDTH / 2);
        ctx.quadraticCurveTo(point.x - scaleX * BRUSH_WIDTH / 2, point.y + scaleY * BRUSH_WIDTH, point.x - scaleX * BRUSH_WIDTH / 2, point.y);
        ctx.quadraticCurveTo(point.x - scaleX * BRUSH_WIDTH / 2, point.y - scaleY * BRUSH_HEIGHT, point.x, point.y - scaleY * BRUSH_HEIGHT);
        ctx.fill();

        // ctx.globalAlpha = alpha;
        // ctx.drawImage(this.image, point.x - scaleX * BRUSH_WIDTH / 2, point.y - scaleY * BRUSH_HEIGHT, scaleX * BRUSH_WIDTH, scaleY * BRUSH_HEIGHT);
    },
    updatePosition: function () {
        if (!this.startTime)
            this.startTime = new Date().getTime() - 20000;
        var now = new Date().getTime();
        var deltaTime = now - this.startTime;

        this.alpha = Math.min(this.alphaMin + (Math.sin((deltaTime / this.alphaAnimTime) * Math.PI + this.alphaAnimOffset) * .5 + .5) * this.alphaVariance, 1);
        this.scaleY = this.scaleYMin + (Math.sin((deltaTime / this.scaleYAnimTime) * Math.PI + this.scaleYAnimOffset) * .5 + .5) * this.scaleYVariance;
        //this.z = this.zMin + (Math.sin((deltaTime / this.zAnimTime) * Math.PI + this.zAnimOffset) * .5 + .5) * this.zVariance;
        this.z = ((deltaTime / this.zAnimTime) + this.zAnimOffset) * this.curve.endPoint.z;
        if (this.z > this.curve.vanishingPoint.z)
            this.z *= this.z;
        if (this.z > this.curve.endPoint.z) {
            this.z = (this.z - this.curve.endPoint.z) + this.curve.vanishingPoint.z;
            // reset start time so it doesn't infinitely speed up
            this.startTime = now;
        }
    }
}

// make a canvas and do stuff
/**
*  NorthernLights class
*  Creates a canvas that immitates the northern lights
*  @param parentElement - DOMElement to append the canvas to
*  [@param width] - width of canvas, defaults to window size on creation
*  [@param height] - height of canvas, defaults to window size on creation
*  [@param curves] - an array of Curve objects to use, creates one if omitted
*/
var NorthernLightsDiv = {};
var NorthernLights = function (parentElement, width, height, curves) {
    // DEBUG = true;
    this.parentElement = parentElement;
    this.width = width || window.innerWidth;
    this.height = height || window.innerHeight;
    this.height = (this.height * .5);
    this.canvas = document.createElement('canvas');
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.ctx = this.canvas.getContext('2d');
    this.ctx.globalCompositeOperation = "color-dodge";

    // make a new random curve if one wasn't passed
    this.curves = curves || [new Curve(this.width * .1, this.height * .59, this.width * .9, this.height * .24)];

    if (DEBUG) {
        this.fpsDisplay = document.createElement('span');
        this.fpsDisplay.style.position = "fixed";
        this.fpsDisplay.style.top = "0";
        this.fpsDisplay.style.left = "0";
        this.fpsDisplay.style.background = "#333";
        this.fpsDisplay.style.color = "#0f0";
        document.body.appendChild(this.fpsDisplay);
    }

    // auto start
    this.start();
    var lightsContainer = document.querySelector('.lightsContainer');
    // var canvas = document.createElement('canvas');
    NorthernLightsDiv = this.canvas
    lightsContainer.appendChild(NorthernLightsDiv);
    // lightsContainer.insertBefore(this.canvas, document.querySelector('.scenery__container__background__mountains'));
}
NorthernLights.prototype = {
    start: function () {
        console.log('Start');
        this.running = true;
        var _this = this;
        var lastTime = new Date().getTime();
        (function anim() {
            // clear current
            _this.ctx.clearRect(0, 0, _this.width, _this.height);
            for (var i = 0, len = _this.curves.length; i < len; i++) {
                // update positions
                _this.curves[i].update();
                // put that bitch on the canvas
                _this.curves[i].draw(_this.ctx);
                // debug line?
                if (DEBUG) {
                    _this.ctx.globalCompositeOperation = "source-over";
                    _this.ctx.globalAlpha = 1;
                    _this.curves[i].drawDebug(_this.ctx);
                    _this.ctx.globalCompositeOperation = "color-dodge";

                    var now = new Date().getTime();
                    _this.fpsDisplay.innerText = Math.round(1000 / (now - lastTime));
                    lastTime = now;
                }
            }
            if (_this.running)
                requestAnimationFrame(anim);
        })()
    },
    pause: function () {
        this.running = false;
    },
    getCanvas: function () {
        return this.canvas;
    },
    getCurves: function () {
        return this.curves;
    }
}

var gradCanvas = document.createElement('canvas');
var gradCtx = gradCanvas.getContext('2d');
var grad = gradCtx.createLinearGradient(window.innerWidth * .5, window.innerHeight, window.innerWidth * .35, 0);
grad.addColorStop(.4, "rgb(50, 130, 140)");
grad.addColorStop(.6, "rgba(100, 100, 120, .5)");
var grad2 = gradCtx.createLinearGradient(window.innerWidth * .5, window.innerHeight * .5, window.innerWidth * .3, 0);
grad2.addColorStop(.35, "rgb(50, 130, 80)");
grad2.addColorStop(.7, "rgba(50, 70, 100,.7)");

var curves = [
    new Curve(window.innerWidth * .17, window.innerHeight * .94, .01, window.innerWidth * .8, window.innerHeight * .8, .8, BRUSH_COUNT * .3, .4, "rgb(60, 150, 120)"),
    new Curve(window.innerWidth * .1, window.innerHeight * .9, .05, window.innerWidth * .8, window.innerHeight * .4, 1, null, .8, grad),
    new Curve(window.innerWidth * .25, window.innerHeight * .65, .33, window.innerWidth * .55, 0, 1.1, BRUSH_COUNT * .6, 1, grad2)
]


var selectedDiv = null;
$(document).ready(function () {
    window.saveText = function () {
        if (!window.editorInstance) {
            console.error('Editor instance is not initialized!');
            return;
        }
        var content = editorInstance.getData();
        if (!content) return;

        var cardFront = document.querySelector('.custom-card-front');
        var cardInside = document.querySelector('.custom-card-inside');
        var stageFront = document.getElementById('stage-front');
        var stageInside = document.getElementById('stage-inside');

        var newTextElement = document.createElement("div");
        var itemId = 'element_'+Date.now()
        newTextElement.innerHTML = content;
        newTextElement.id = itemId;
        newTextElement.classList.add("draggable-text");
        newTextElement.classList.add("text-to-save");
        newTextElement.classList.add("d-inline-block");
        newTextElement.classList.add("active-text");
        selectedDiv = newTextElement;
        
        if (cardFront.classList.contains('hide')) {
            stageInside.appendChild(newTextElement);
            newTextElement.setAttribute('data-stage',"stage-inside");

        } else if (cardInside.classList.contains('hide')) {
            newTextElement.setAttribute('data-stage',"stage-front");
            stageFront.appendChild(newTextElement);
        }

        jQuery(newTextElement).draggable({
            containment: cardFront.classList.contains('hide') ? "#stage-inside" : 
                "#stage-front",
            scroll: false,
            axis: null,
            stop: function(event, ui) {
                updateElementArray(newTextElement.id, newTextElement);
            }
        });

        updateElementArray(itemId, newTextElement)
        editorInstance.setData('')
    }
});

document.addEventListener('click', function(e) {
    if (e.target.closest('.draggable-text')) {
        selectedDiv = e.target.closest('.draggable-text'); // Set the selected div
        jQuery('.active-text').removeClass('active-text');
        selectedDiv.classList.add('active-text');
    }
})

document.querySelectorAll('.object-toolbar__option').forEach(function (toolbarOption) {
    toolbarOption.addEventListener('click', function () {
        if (selectedDiv) {
            // Get the data-classes attribute from the clicked toolbar option

            const dataClasses = this.getAttribute('data-classes');
            if (dataClasses) {
                // Remove any existing classes from the selected div
                selectedDiv.className = 'draggable-text text-to-save d-inline-block ui-draggable ui-draggable-handle '+dataClasses;
                // Add the classes from the data-classes attribute
            }
            updateElementArray(selectedDiv.id, selectedDiv);
        } else {
            // alert('Please select a text element before applying styles.');
        }
    });
});
document.querySelectorAll('.background-color-grad').forEach(function (backgroundOptions) {
    backgroundOptions.addEventListener('click', function () {
        // Determine the active stage
        const cardFront = document.querySelector('.custom-card-front');
        const STAGE = !cardFront.classList.contains('hide') ? "stage-front" : "stage-inside";
        const stageElement = document.getElementById(STAGE);

        // Get the data-classes attribute
        const dataClasses = this.getAttribute('data-classes');
        console.log(dataClasses, 'classes');
        
        if (dataClasses) {
            // Add the new classes (support for multiple classes)
            if (STAGE === 'stage-front') {
                stageElement.className = 'custom-card-front__dummy-stage ' + dataClasses;
            } else {
                stageElement.className = 'custom-card-inside__dummy-stage ' + dataClasses;
            }
        }
    });
});
// Element manipulation specifically for text boxes
// document.getElementById('ctrlRemove').addEventListener('click', function() {
//     if (selectedDiv != null) {
//         selectedDiv.remove();
//     }
// });

function increaseZIndex(element) {
    const currentZIndex = parseInt(getComputedStyle(element).zIndex) || 0;
    element.style.zIndex = currentZIndex + 1;
}

function decreaseZIndex(element) {
    const currentZIndex = parseInt(getComputedStyle(element).zIndex) || 0;
    element.style.zIndex = currentZIndex - 1;
}

document.getElementById('ctrlRaise').addEventListener('click', function() {
    if (selectedDiv != null) {
        increaseZIndex(selectedDiv);
    }
});

document.getElementById('ctrlLower').addEventListener('click', function() {
    if (selectedDiv != null) {
        decreaseZIndex(selectedDiv);
    }
});

document.getElementById('ctrlUndo').addEventListener('click', function() {
    if (selectedDiv != null) {
        decreaseZIndex(selectedDiv);
    }
});